import React, { useEffect, useMemo, useRef, useState, useCallback } from 'react';
import {
  IonButton,
  IonCol,
  IonContent,
  IonIcon,
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonRow,
  useIonToast,
} from '@ionic/react';
import { useHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import {
  ICasinoSearchData,
  IState,
  ITabProperties,
  SlotMetaData,
  useAppSelector,
} from 'appRedux/createStore';
import { ICasinoReport, ICasinoSchema, ITrendsReport } from 'appRedux/models/casinoModels';
import HotListReport from './HotListReport/HotListReport';
import FloorMap from 'components/FloorMapPackage/components/floorMap';
import clsx from 'clsx';
import { InsightValue } from 'common/types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown, faCaretUp } from '@fortawesome/free-solid-svg-icons';
import { config } from 'config/config';
import { featureFlags } from 'config/featureFlags';
import HotListHeader from './HotListReport/components/HotListHeader';
import NoDetailsNotice from './HotListReport/components/NoDetailsNotice';
import FavoritesEmptyNotice from './HotListReport/components/FavoritesEmptyNotice';
import PlaylistEmptyNotice from './HotListReport/components/PlaylistEmptyNotice';
import { CasinoService, IRequestCasinoParams } from 'services/casino';
import { Subscription } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import {
  FilterTypeEnum,
  getCleanGameName,
  heatLegendAllInsight,
  heatLegendJackpots,
  IFilterType,
  MapTypeEnum,
  OrderByEnum,
  TimeFrameValueEnum,
} from 'common/common';
import useFetchGeoJson from 'common/reactHooks/useFetchGeoJson';
import {
  canShowOnMap,
  egmDetailId,
  egmDetailKey,
  filterRowsBySlotFilter,
  IInsightRow,
  isInsightCardRow,
  isInsightCasinoSchema,
  matchesEgmDetailId,
} from 'services/insightCasino';
import {
  getHeatFilterForSortDirection,
  getInsightHeatFilterReset,
  getOrderbyForSortChange,
  JACKPOT_INSIGHTS,
} from './insightHeatFilterReset';
import { exploreListMountStyle } from './exploreListMountStyle';
import { IListResponse } from '@interfaces/services';
import { isInsightTimeframeValue, resolveInsightTimeframe } from 'config/insightTimeframes';
import {
  EXPLORE_DEFAULT_TIMEFRAME_FALLBACK,
  getExploreDefaults,
  getExploreDefaultTimeframe,
} from 'lib/exploreDefaults';
import { ReduxCommandCreator } from 'appRedux/actions';
import useSlotDetailHistory from 'globalServices/useSlotDetailHistory';
import { FilterReduxCommandCreator } from 'appRedux/actions/filterCommandCreator';
import { InsightValueEnum } from 'config/Insights';
import { FloormapReduxCommandCreator } from 'appRedux/actions/floormapCommandCreator';
import SVGComponent from 'components/SmartLoading/SVGComponent';
import ShortcutBar, { Shortcut } from 'components/ShortcutBar/ShortcutBar';
import CompareView from './HotListReport/components/CompareView';
import { SlotCompareReduxCommandCreator } from 'appRedux/actions/slotCompareCommandCreator';
import { useCloakedMnums } from 'hooks/useCloakedMnums';
import { rejectCloaked } from 'lib/rejectCloaked';
import { selectShowLoadingReels } from 'lib/showLoadingReels';
import { rejectZeroJackpotEgms } from 'lib/rejectZeroJackpotEgms';
import {
  appendWithoutReorder,
  listSortScopeKey,
  nextListPageNumber,
} from 'lib/stableEgmListOrder';
import { isInsightSearchCasino as isInsightSearchInstance } from 'lib/insightSearchGate';
import ListSheet, { SnapPoint, SnapPointType } from './HotListReport/components/ListSheet';
import {
  decideDrawerFiltersVisibility,
  isLiveScrollElement,
  computeUpwardScrollVelocityPxPerMs,
  pruneScrollSamples,
  createDrawerFiltersFlickTracker,
  updateDrawerFiltersFlickTracker,
  clampScrollTop,
  isScrollNearBottom,
  shouldEndInfiniteScroll,
  DRAWER_FILTERS_HIDE_SCROLL_TOP,
  DRAWER_FILTERS_SHOW_SCROLL_TOP,
  DRAWER_FILTERS_TOGGLE_COOLDOWN_MS,
  DRAWER_FILTERS_FLICKS_TO_REVEAL,
  DRAWER_SCROLL_NEAR_BOTTOM_PX,
  type DrawerFiltersScrollSample,
  type DrawerFiltersFlickTracker,
} from './drawerFiltersScroll';
import { getExploreLoadingMode } from './exploreLoadingMode';
import { exploreListPhaseClass, shouldShowExploreSkeleton } from './exploreSkeleton';
import { pickCasinoLogoSrc } from './slotReels';
import ExploreLoadingSkeleton, {
  useExploreSkeletonPhase,
} from './HotListReport/components/ExploreLoadingSkeleton';
import { useExploreSectionsCollapsed } from './useExploreSectionsCollapsed';
import { setExploreReady } from 'lib/exploreReadySignal';
import RemovableTag from './HotListReport/components/RemovableTag';
import DetailReport from './HotListReport/DetailReport';
import DetailReportV2 from './HotListReport/DetailReportV2';
import CompareAdvancedView from './HotListReport/components/CompareAdvancedView/CompareAdvancedView';
import UserMessages from 'components/UserMessages/UserMessages';
import { AuthService, IUserMessage } from 'services/auth';
import { SlotReduxCommandCreator } from 'appRedux/actions/slotCommandCreator';
import { takeUniversalSearchCasinoFilter } from 'lib/universalSearchSession';
import { applyUniversalSearchFilter } from 'lib/universalSearchEntry';
import { setUniversalSearchExploreLabel } from 'lib/universalSearchExploreLabel';
import { trackUsCasinoEntered } from 'lib/universalSearchAnalytics';
import { CasinoReduxCommandCreator } from 'appRedux/actions/casinoCommandCreator';
import { selectFavoritesList, selectPlaylist, selectCasinoId, selectUserId } from 'appRedux/selectors';
import { applyBankFilter, clearBankFilter } from 'lib/applyBankFilter';
import { decideBankLabelTap, shouldRaiseDrawerForBankTap } from 'lib/bankLabelTap';
import usePlaylist, { isIncludedInPlaylist } from 'common/reactHooks/usePlaylist';
import useFavorites from 'common/reactHooks/useFavorites';
import useSelectedEgms from 'common/reactHooks/useSelectedEgms';
import { isIncludedInFavorites } from 'pages/Favorites/components/LikeButton';
import {
  FOOTER_VISIBILITY_EVENT,
  FooterVisibilityEventDetail,
} from 'common/footerVisibility';
import {
  invalidatePlayerScoped,
  playerScopedKey,
  selectedEgmsListBucket,
  sharedPlayerScopedGet,
  userMessagesListBucket,
} from 'lib/playerScopedListCache';
import { ensureRotateLandscapeMessage } from 'lib/ensureUserMessage';

// Enum for view modes
export enum ViewMode {
  Portrait = 'portrait',
  Landscape = 'landscape',
  ComparePortrait = 'comparePortrait',
  CompareLandscape = 'compareLandscape',
}

// Jackpot insights for which the "none of your saved EGMs hit a jackpot"
// messaging applies on the Favorites/Playlist filtered views.
const JACKPOT_MESSAGE_INSIGHTS = ['jackpot_value', 'jackpots', 'jackpot_value_per_spin'];

const SELECT_TOP_LIMIT = 10;

// Page size used to pull an entire casino floor in one ListReport request for
// challenge mode, where the list is filtered to the challenge's EGMs client-side
// (see fetchListReport). Large enough to cover any real floor in a single page.
const CHALLENGE_FULL_FLOOR_LIMIT = 100000;

// Stable reference so forcing the report map's data to empty doesn't create a
// new array each render (which would re-run FloorMap's heat/marker effects).
const EMPTY_MAP_SLOT_DATA: ICasinoReport[] = [];

const MapStats: React.FC = () => {
  // View mode calculation using isLandscapeOnly

  const history = useHistory();
  const casinoSvc = useMemo(() => new CasinoService(), []);
  const itemsPerPage = 50;
  const tabSelected = FilterTypeEnum.hottestSlots;
  const listType = 'standard';
  const ionInfiniteScrollRef = useRef<HTMLIonInfiniteScrollElement>(null);
  const [presentToast] = useIonToast();
  const dispatch = useDispatch();
  const filterCommandCreator = FilterReduxCommandCreator(dispatch);
  const slotCompareCommands = SlotCompareReduxCommandCreator(dispatch);
  const slotCommands = SlotReduxCommandCreator(dispatch);
  const casinoCommands = CasinoReduxCommandCreator(dispatch);

  const {
    selectedSlots: selectedToCompare,
    compareSlots,
    isComparing,
  } = useAppSelector((state) => state.app.persistedState.compareSlotsState);
  const commands = ReduxCommandCreator(dispatch);
  const selectedSlots = useSelector<IState>(
    (state) => state.app.persistedState.slotState.selectedSlots
  ) as string[];

  const { selectedSlotsName, isBankFilter, challengeName } = useAppSelector(
    (state) => state.app.persistedState.slotState
  );
  const casinoSearchData = useSelector<IState>(
    (state) => state.app.persistedState.casinoSearchData
  ) as ICasinoSearchData | undefined;

  // Bumped on every casino selection (including re-selecting the current
  // casino) so the "fresh entry" reset below re-runs each time the user enters
  // a casino from the selection screen.
  const casinoEntrySeq = useSelector<IState>(
    (state) => state.app.persistedState.casinoEntrySeq
  ) as number;

  const tabFilters = useSelector<IState>(
    (state) => state.app.persistedState.filterState[tabSelected as IFilterType]
  ) as ITabProperties;
  const casinoSchema: ICasinoSchema = useSelector<IState>(
    (state) => state.app.persistedState.casinoSchema
  ) as ICasinoSchema;
  const {
    timeframe: tabSelectedTimeframe,
    insight: tabSelectedInsight,
    advancedViewInsights,
    orderby: tabSelectedOrderby,
  } = tabFilters;

  const fieldSelectorValues = advancedViewInsights?.map((insight: string) => ({
    value: insight,
    label: insight,
  }));
  const { addToSlotHistory, activeSlotNumber, clearSlotHistory } = useSlotDetailHistory();

  const isLandscape = useSelector<IState>(
    (state) => state.app.persistedState.orientationState?.isOnlyPortrait
  ) as boolean;

  const isLandscapeOnly = useSelector<IState>(
    (state) => state.app.persistedState.orientationState?.isLandscape
  ) as boolean;

  let viewMode: ViewMode;
  if (isComparing && isLandscapeOnly) {
    viewMode = ViewMode.CompareLandscape;
  } else if (isComparing && !isLandscapeOnly) {
    viewMode = ViewMode.ComparePortrait;
  } else if (isLandscapeOnly) {
    viewMode = ViewMode.Portrait;
  } else {
    viewMode = ViewMode.Portrait;
  }
  const [activeInsightFilter, setActiveInsightFilter] = useState<null | InsightValue>(
    tabSelectedInsight
  );
  const [selectedSlot, setSelectedSlot] = useState<ICasinoReport | null>(null);
  const [userMessagesVisible, setUserMessagesVisible] = useState<boolean>(false);
  const appUserPk = useSelector<IState>((state) => state.app.persistedState.userInfo?.appUserPk);
  const authSvc = useMemo(() => new AuthService(), []);

  const [currentMessage, setCurrentMessage] = useState<{
    _id?: string;
    templateKey?: string;
    title?: string;
    description?: string;
    shownDate?: number;
    isVisible?: boolean;
  } | null>(null);

  const handleUserMessagesClose = useCallback(() => {
    const msg = currentMessage;
    if (appUserPk && msg) {
      authSvc.UpdateUserMessageShownDate(msg._id).subscribe?.();
    }
    setUserMessagesVisible(false);
  }, [appUserPk, authSvc, casinoSchema?.kpCasinoPk, commands, currentMessage]);

  // Message stays visible until user explicitly closes it — no auto-dismiss

  useEffect(() => {
    let sub: Subscription | null = null;
    if (casinoSchema?.kpCasinoPk) {
      // Timeframe-independent: once per user+casino with in-flight dedupe.
      const msgKey = playerScopedKey(
        String(appUserPk || 'anon'),
        casinoSchema?.casinoId
      );
      // Wait for the (once-per-session, shared with Home) rotate-landscape
      // CreateUserMessage before reading, so a first visit sees the new message
      // instead of racing the create. Resolves immediately once ensured.
      sub = sharedPlayerScopedGet(userMessagesListBucket, msgKey, () =>
        ensureRotateLandscapeMessage(
          authSvc,
          appUserPk as string | undefined,
          casinoSchema?.casinoId
        ).pipe(
          switchMap(() =>
            authSvc.GetUserMessages(appUserPk as string | undefined, casinoSchema?.casinoId)
          )
        )
      ).subscribe((resp) => {
        const list = resp && resp.DataSet ? (resp.DataSet as IUserMessage[]) : [];
        if (list.length > 0) {
          const m = list[0];
          setCurrentMessage({
            _id: m._id,
            templateKey: m.templateKey || m.templatekey || m.key,
            title: m.title,
            description: m.description,
            shownDate: m.shownDate || m.shown,
            isVisible: typeof m.isVisible === 'undefined' ? true : m.isVisible,
          });
          setUserMessagesVisible(true);
        }
      });
    }
    return () => {
      if (sub && sub.unsubscribe) sub.unsubscribe();
    };
  }, [authSvc, casinoSchema?.kpCasinoPk, casinoSchema?.casinoId, appUserPk]);

  const [playData, setPlayData] = useState<ICasinoReport[]>();
  const [hotDataList, setHotDataList] = useState<ICasinoReport[]>([]);
  // Cloaked EGMs are hidden client-side (the Explore list API deliberately doesn't
  // know about them), so subtract them once here and let the drawer list, the
  // select-all/top-10 actions and the map's pins all work off the same set. If they
  // diverged, a cloaked EGM would still take a pin and a pin number, and every pin
  // below it would stop matching its list row.
  //
  // On Jackpots / JW/S insights, also drop EGMs with amount<=0 or count<=0
  // (frontend-only; see rejectZeroJackpotEgms).
  //
  // hotDataList stays raw for the infinite-scroll accounting below, which compares
  // against the server's totalCount.
  const cloakedMnums = useCloakedMnums(casinoSchema?.casinoId);
  const visibleHotDataList = useMemo(
    () =>
      rejectZeroJackpotEgms(rejectCloaked(hotDataList, cloakedMnums), tabSelectedInsight),
    [hotDataList, cloakedMnums, tabSelectedInsight]
  );
  const [trendComparisonMap, setTrendComparisonMap] = useState<ITrendsReport[]>([]);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [isEndReached, setIsEndReached] = useState<boolean>(false);
  const [isCasinoLoading, setCasinoLoading] = useState(false);
  const [isListReportLoading, setListReportLoading] = useState(false);

  const [statsRef, setStatsRef] = useState<HTMLDivElement | null>(null);

  const [isSlotPlayDataIsLoading, setSlotPlayDataIsLoading] = useState(false);
  const {
    geoJsonData,
    getGeoJsonLoading,
    slotMetaData: legacySlotMetaData,
    slotMetaDataLoading,
    isMapless,
    isInsightGeoJsonLoading,
    geoJsonError,
    retryGeoJson,
  } = useFetchGeoJson(casinoSchema?.kpCasinoPk);
  // Gate ONLY on the casino object's insightInstance field (no casino ids).
  const isInsightCasino = isInsightCasinoSchema(casinoSchema);
  // Explore entry defaults from applicationConfigurations (lib/exploreDefaults):
  // exploreDefaultInsight + exploreDefaultTimeframe / exploreDefaultTimeframeInsightCasino.
  // Missing/invalid → Hottest (RTP Desc) + 7d for every casino.
  // Re-read when GetApplicationConfigurations lands (non-persisted Redux).
  const applicationConfigurations = useSelector<IState>((s) => s.app.applicationConfigurations);
  const exploreDefaults = useMemo(() => {
    void applicationConfigurations;
    return getExploreDefaults(isInsightCasino);
  }, [applicationConfigurations, isInsightCasino]);
  // Insight casinos only offer 1h..30d; coerce anything else (e.g. SLJ kept
  // from another casino) to the insight-casino default timeframe.
  useEffect(() => {
    if (!isInsightCasino || isInsightTimeframeValue(tabSelectedTimeframe)) return;
    filterCommandCreator.SetFilterOptions(tabSelected, { timeframe: exploreDefaults.timeframe });
  }, [isInsightCasino, tabSelectedTimeframe, exploreDefaults.timeframe]);
  // Insight casinos never call GetMapMetaData: area/section placement comes
  // from the FULL GetCasinoInsights summary rows (same shared request as the
  // list and map, so no extra call), including onMap:false machines.
  const [insightRows, setInsightRows] = useState<IInsightRow[]>([]);
  // Single resolved id for summary/list/map from first paint. Insight Explore
  // always opens on its entry default (matches the casino-entry reset below), so
  // we do not briefly request a stale redux timeframe then immediately re-request.
  const resolvedExploreTimeframeId = resolveInsightTimeframe(
    isInsightCasino ? exploreDefaults.timeframe : tabSelectedTimeframe
  ).id;
  const floormapCommand = FloormapReduxCommandCreator(dispatch);
  const isTopTenSlot = useSelector<IState>(
    (state) => state.app.persistedState.isSlotOrderAscending
  ) as boolean;

  // First-load sequence (map casinos): spinner → map under spinner → drawer.
  // After explorePrimed, timeframe refetches keep map+drawer and hide chrome.
  const [explorePrimed, setExplorePrimed] = useState(false);
  const dataLoading =
    isSlotPlayDataIsLoading || isCasinoLoading || slotMetaDataLoading;
  const hasFloorGeometry =
    !isMapless && !getGeoJsonLoading && !!geoJsonData;

  useEffect(() => {
    setExplorePrimed(false);
  }, [casinoSchema?.kpCasinoPk, casinoEntrySeq]);

  useEffect(() => {
    if (isMapless) return;
    if (hasFloorGeometry && !dataLoading) setExplorePrimed(true);
  }, [isMapless, hasFloorGeometry, dataLoading]);

  const {
    showFullScreenSpinner,
    showDrawer,
    isEgmRefreshing,
    hideDrawerChrome,
  } = getExploreLoadingMode({
    isMapless,
    getGeoJsonLoading,
    hasGeoJsonData: !!geoJsonData,
    isSlotPlayDataIsLoading,
    isCasinoLoading,
    slotMetaDataLoading,
    explorePrimed,
    skeletonFirstLoad: true,
  });

  // Display-only loading skeleton for the drawer's list area: placeholder EGM cards while
  // the insight data loads (first load, insight/timeframe change, list refetch). Reads the
  // existing loading flags only; never gates or triggers a fetch.
  // Slot-reel cards and the check-check-check finale when the data lands (only while the
  // drawer is up; closing it mid-load keeps the plain fade) when the casino has
  // showLoadingReels = 1 OR the logged-in user opted in (users.showLoadingReels = 1), see
  // lib/showLoadingReels.ts. Otherwise the original gray pulsing cards and cross-fade.
  const showLoadingReels = useSelector(selectShowLoadingReels);
  const showListSkeleton = shouldShowExploreSkeleton({
    showDrawer,
    isListReportLoading,
    dataLoading,
    awaitingFirstData: !isMapless && !explorePrimed,
  });
  const skeletonPhase = useExploreSkeletonPhase(showListSkeleton, {
    reelFinale: showDrawer && showLoadingReels,
  });
  // The current casino's logo as a reel symbol (logoAlt, else navBar, else left out).
  const reelLogoSrc = pickCasinoLogoSrc(casinoSchema);

  // Display-only: slide the Insight + Timeframe sections out while the list loads (the
  // skeleton is visible, so the same ~120ms no-flash delay) and back in when the cards
  // land; also held out while the post-login Random Outcomes drawer holds the cards.
  // Derived layer on top of the scroll auto-hide (isDrawerFiltersVisible), never a
  // replacement for it.
  const exploreSectionsCollapsed = useExploreSectionsCollapsed({
    showDrawer,
    skeletonVisible: skeletonPhase.visible,
  });

  // Display-only: tell the post-login Random Outcomes drawer when Explore's drawer is up so it
  // can hand off to it. Carries no casino/insight data.
  useEffect(() => {
    setExploreReady(showDrawer);
    return () => setExploreReady(false);
  }, [showDrawer]);

  // Keep the full-screen spinner mounted through a 500ms opacity fade-out.
  const [spinnerMounted, setSpinnerMounted] = useState(false);
  const [spinnerOpaque, setSpinnerOpaque] = useState(false);
  useEffect(() => {
    if (showFullScreenSpinner) {
      setSpinnerMounted(true);
      // Next frame so the visible class can transition from 0 → 1 if needed.
      const id = window.requestAnimationFrame(() => setSpinnerOpaque(true));
      return () => window.cancelAnimationFrame(id);
    }
    setSpinnerOpaque(false);
    const t = window.setTimeout(() => setSpinnerMounted(false), 500);
    return () => window.clearTimeout(t);
  }, [showFullScreenSpinner]);

  const isProUser = useSelector<IState>(
    (state) => state.app.persistedState.userInfo?.isProUser
  ) as boolean;
  const favoritesList = useSelector(selectFavoritesList);
  const playlist = useSelector(selectPlaylist);
  const casinoId = useSelector(selectCasinoId);
  const userId = useSelector(selectUserId);
  const isPlaylistEnabled = featureFlags.playlist;
  const { fetchUserPlaylist, handleInsertPlaylistBulk, handleDeletePlaylistBulk } = usePlaylist();
  const { fetchUserFavorites, handleInsertFavoriteBulk, handleDeleteFavoriteBulk } = useFavorites({});
  const { fetchUserSelectedEgms, persistSelectedEgms } = useSelectedEgms();


  const [casinoParams, setCasinoParams] = useState<IRequestCasinoParams>({
    casinofk: casinoSchema?.kpCasinoPk,
    timeframe: resolvedExploreTimeframeId,
    insight: exploreDefaults.insight,
    slot: 0,
    slotnumbers: '',
    compareSlotNumbers: '',
    limit: itemsPerPage,
    pageNumber: 0,
    orderby: isTopTenSlot ? OrderByEnum.Desc : OrderByEnum.Asc,
  });

  // Placement meta for insight casinos: same shared GetCasinoInsights call as
  // the list/map (keyed on casinoParams.timeframe — one id, one request).
  useEffect(() => {
    if (!isInsightCasino || !casinoSchema?.kpCasinoPk) {
      setInsightRows([]);
      return;
    }
    const sub = casinoSvc
      .GetInsightSummary(casinoSchema.kpCasinoPk, casinoParams.timeframe)
      .pipe(catchError(() => of(null)))
      .subscribe((resp) => setInsightRows(resp?.DataSet ?? []));
    return () => sub.unsubscribe();
  }, [isInsightCasino, casinoSchema?.kpCasinoPk, casinoParams.timeframe]);
  const slotMetaData = useMemo((): IListResponse<SlotMetaData> | undefined => {
    if (!isInsightCasino) return legacySlotMetaData;
    const rows: SlotMetaData[] = insightRows
      .map((r) => {
        const id = egmDetailId(r);
        if (id === null) return null;
        return {
          game_name: r.game_name ?? '',
          // Insight EGM id is mnum (egmDetailId); slot_number/floorLocation is placement-only.
          slot_number: id,
          area: r.area ?? '',
          section: r.section ?? '',
          location: r.location ?? '',
        };
      })
      .filter((r): r is SlotMetaData => r !== null);
    return {
      DataSet: rows,
      totalCount: rows.length,
      lastUpdated: '',
      Metadata: { recordCount: rows.length },
    } as IListResponse<SlotMetaData>;
  }, [isInsightCasino, legacySlotMetaData, insightRows]);

  const handleInputChange = (param: keyof IRequestCasinoParams, value: string | number) => {
    setCasinoParams((prevParams) => ({ ...prevParams, [param]: value }));
  };

  useEffect(() => {
    const newOrderBy = isTopTenSlot ? OrderByEnum.Desc : OrderByEnum.Asc;
    setCasinoParams((prevParams) => {
      if (prevParams.orderby === newOrderBy) return prevParams;
      return { ...prevParams, orderby: newOrderBy, pageNumber: 0 };
    });
  }, [isTopTenSlot]);

  useEffect(() => {
    if (tabSelectedOrderby) {
      setCasinoParams((prevParams) => {
        if (prevParams.orderby === tabSelectedOrderby) return prevParams;
        return { ...prevParams, orderby: tabSelectedOrderby, pageNumber: 0 };
      });
    }
  }, [tabSelectedOrderby]);

  const [isFavoritesActive, setIsFavoritesActive] = useState(false);
  const [isPlaylistActive, setIsPlaylistActive] = useState(false);
  // "Selected" review filter (drawerActionButtons flag): when on, the list is
  // filtered to the user's current cross-list selection so they can review it.
  const [isSelectedActive, setIsSelectedActive] = useState(false);

  // Tracks the last insight applied to the heat map so the insight-change effect
  // can tell a real user-driven insight switch from a reset we performed here.
  const prevInsightRef = useRef<string>(tabSelectedInsight);

  // After casino-entry defaults, skip one timeframe sync flush so a stale redux
  // timeframe cannot overwrite the entry timeframe id and double-fetch.
  const skipTimeframeSyncRef = useRef(false);

  // Legacy (non-insight) timeframe value → GetCasino* timeframe id.
  const legacyTimeframeId = (value: string): number =>
    config.allTimeFrames.find((tf) => tf.value === value)?.id ??
    config.allTimeFrames.find((tf) => tf.value === EXPLORE_DEFAULT_TIMEFRAME_FALLBACK)?.id ??
    5;

  // Which entry the defaults were last applied for, and what was applied, so a
  // config that lands after entry (GetApplicationConfigurations still in flight)
  // can re-apply — but only while the user is still on the applied defaults.
  const lastEntryKeyRef = useRef<string | null>(null);
  const lastAppliedDefaultsRef = useRef<{ insight: string; timeframe: string } | null>(null);

  // Set defaults on every casino entry: the Explore default insight (Desc) +
  // timeframe from applicationConfigurations (lib/exploreDefaults; fallback
  // Hottest Slots + 7 days for every casino), and clear any
  // Favorites/Playlist list filter carried over from the previous casino so the
  // casino starts on the default ALL EGM view. Keyed on casinoEntrySeq as well
  // as kpCasinoPk so re-selecting the casino already in view (same kpCasinoPk)
  // still resets to the default view.
  useEffect(() => {
    if (!casinoSchema?.kpCasinoPk) return;

    const entryKey = `${casinoSchema.kpCasinoPk}|${appUserPk ?? ''}|${casinoEntrySeq ?? ''}`;
    const { insight: entryInsight, timeframe: entryTimeframe, orderby: entryOrderby } = exploreDefaults;
    // Clears the one-shot sync skip after this flush. Also scheduled when this
    // run makes no change, because re-running cancelled the previous timer.
    const scheduleClearSkip = () => {
      const clearSkip = window.setTimeout(() => {
        skipTimeframeSyncRef.current = false;
      }, 0);
      return () => window.clearTimeout(clearSkip);
    };
    if (lastEntryKeyRef.current === entryKey) {
      // Same entry, defaults changed (config arrived late). Leave a user's own
      // choice alone; only move off the previously applied defaults.
      const prev = lastAppliedDefaultsRef.current;
      const userChanged =
        !prev ||
        tabSelectedInsight !== prev.insight ||
        tabSelectedTimeframe !== prev.timeframe ||
        (!!tabSelectedOrderby && tabSelectedOrderby !== entryOrderby);
      const unchanged = !!prev && prev.insight === entryInsight && prev.timeframe === entryTimeframe;
      if (userChanged || unchanged) return scheduleClearSkip();
    }
    lastEntryKeyRef.current = entryKey;
    lastAppliedDefaultsRef.current = { insight: entryInsight, timeframe: entryTimeframe };

    filterCommandCreator.SetFilterOptions(tabSelected, {
      insight: entryInsight,
      timeframe: entryTimeframe,
      orderby: entryOrderby,
    });
    commands.SetSlotOrderState(true);
    const entryTimeframeId = isInsightCasino
      ? resolveInsightTimeframe(entryTimeframe).id
      : legacyTimeframeId(entryTimeframe);
    setIsFavoritesActive(false);
    setIsPlaylistActive(false);
    setIsSelectedActive(false);
    // Ignore one stale timeframe sync in this flush (redux may still hold the old value).
    skipTimeframeSyncRef.current = true;
    setCasinoParams((prev) => ({
      ...prev,
      insight: entryInsight,
      timeframe: entryTimeframeId,
      orderby: entryOrderby,
      slotnumbers: '',
      pageNumber: 0,
    }));
    // Apply the heat-map filter for the default insight sorted Desc (for
    // Hottest Slots: the top two heat levels, same as the shortcut). Sync
    // prevInsightRef so the insight-change effect doesn't immediately flip this
    // back to "show all" when the reset switches the insight — that override is
    // only meant for user-driven switches.
    prevInsightRef.current = entryInsight;
    floormapCommand.SetDefaultHeatFilterAction(getHeatFilterForSortDirection(
      entryInsight,
      entryOrderby
    ));
    // If the sync effect does not re-run (redux already on the entry timeframe),
    // clear the skip so later picker changes are not dropped.
    return scheduleClearSkip();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [casinoSchema?.kpCasinoPk, appUserPk, casinoEntrySeq, exploreDefaults]);

  // Slot Check Search hand-off: after the entry reset above, filter Explore to the game
  // tapped in Slot Check Search exactly as the casino's own Slot Search would (and open
  // Details for an EGM tap). One-shot: the intent is consumed for this casino only.
  useEffect(() => {
    if (!casinoSchema?.casinoId) return undefined;
    const t = window.setTimeout(() => {
      const intent = takeUniversalSearchCasinoFilter(casinoSchema?.casinoId);
      if (!intent) return;
      const applied = applyUniversalSearchFilter(intent, {
        setSearchMode: (on) => slotCommands.SetSearchMode(on),
        selectBankFilter: (on) => slotCommands.SelectBankFilter(on),
        setSelectedSlotsName: (name) => slotCommands.SelectedSlotsName(name),
        setSelectedSlots: (ids) => slotCommands.SelectedSlots(ids),
        clearCompareSelection: () => slotCompareCommands.setSlotNumbers({ slotNumbers: [] }),
        openDetail: (id) => addToSlotHistory(id),
      });
      if (applied.applied) {
        setUniversalSearchExploreLabel({ casinoId: intent.casinoId, filterName: intent.filterName });
        trackUsCasinoEntered({
          casinoId: intent.casinoId,
          gameName: intent.filterName,
          egms: applied.slotIds.length,
          openedDetail: applied.openedDetail !== null,
        });
      }
    }, 0);
    return () => window.clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [casinoSchema?.casinoId, casinoEntrySeq]);

  // The selected-EGMs set is persisted per casino (backed by ms-player, the same
  // way playlists/favorites are), so each casino keeps its own selection across
  // casino switches and sessions. The live set still lives in compareSlotsState;
  // these two effects just load it on casino entry and autosave changes back.
  // selectionCasinoIdRef = the casino whose set is currently loaded;
  // lastSyncedSelectionRef = the last value we loaded/saved (to skip echoes).
  const selectionCasinoIdRef = useRef<number | null>(null);
  const lastSyncedSelectionRef = useRef<string>('');
  const buildSelectionKey = (id: number | string, slots: number[]) =>
    `${id}:${[...slots].sort((a, b) => a - b).join(',')}`;

  // Load on casino enter/switch. Slot numbers repeat across casinos, so clear the
  // live set first to avoid flashing the previous casino's machines, then load
  // this casino's saved selection. Keyed on casinoEntrySeq too so re-selecting the
  // casino already in view reloads the saved set: the casino picker clears the live
  // selection on every pick (ChooseCasinos.clearState), and with an unchanged
  // casinoId this effect would otherwise never refire to restore it — leaving the
  // selection wiped on same-casino re-entry.
  useEffect(() => {
    if (!featureFlags.drawerActionButtons) return;
    if (!userId || !casinoId) return;
    selectionCasinoIdRef.current = null;
    slotCompareCommands.setSlotNumbers({ slotNumbers: [] });
    setIsSelectedActive(false);
    // Re-entry (casinoEntrySeq bump) must hit the network again — picker clears
    // local selection. Bust the session cache for this user+casino first.
    invalidatePlayerScoped(
      selectedEgmsListBucket,
      playerScopedKey(String(userId), String(casinoId))
    );
    const sub = fetchUserSelectedEgms(String(userId), String(casinoId), (slotNumbers) => {
      slotCompareCommands.setSlotNumbers({ slotNumbers });
      selectionCasinoIdRef.current = Number(casinoId);
      lastSyncedSelectionRef.current = buildSelectionKey(casinoId, slotNumbers);
    });
    return () => sub?.unsubscribe();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId, casinoId, casinoEntrySeq]);

  // Autosave selection changes back to the backend (debounced). Skip until this
  // casino's set has loaded (so a mid-switch state can't be written to the wrong
  // casino) and skip the no-op echo of the value we just loaded.
  useEffect(() => {
    if (!featureFlags.drawerActionButtons) return;
    if (!userId || !casinoId) return;
    if (selectionCasinoIdRef.current !== Number(casinoId)) return;
    const key = buildSelectionKey(casinoId, selectedToCompare);
    if (key === lastSyncedSelectionRef.current) return;
    const timer = window.setTimeout(() => {
      lastSyncedSelectionRef.current = key;
      persistSelectedEgms(selectedToCompare, String(userId), String(casinoId));
    }, 600);
    return () => window.clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedToCompare, userId, casinoId]);

  const [currentSnap, setCurrentSnap] = useState<SnapPointType>(SnapPoint.Mid);
  // Mirrors currentSnap for effects that need the snap the drawer is resting at
  // right now (state would be a render behind when the snap and the effect's own
  // trigger land in the same update).
  const currentSnapRef = useRef<SnapPointType>(SnapPoint.Mid);
  const searchDataFetchingForRef = useRef<number | null>(null);
  const [drawerForceSnap, setDrawerForceSnap] = useState<SnapPointType | null>(null);
  // Natural pixel height of the compare view's content, reported by
  // CompareAdvancedView. Feeds the compare drawer's fit-to-content open.
  const [compareContentHeight, setCompareContentHeight] = useState(0);
  // Bumped once when compare opens so the drawer snaps to fit the selection.
  const [compareFitSeq, setCompareFitSeq] = useState(0);
  // Single-tapping a map pin focuses its row in the list. focusSeq is bumped on every
  // tap so the same EGM tapped twice still re-triggers the scroll-into-view.
  const [focusedSlotNumber, setFocusedSlotNumber] = useState<number | null>(null);
  const [focusSeq, setFocusSeq] = useState(0);

  // Selecting an EGM (via the list's select circle) flies the map to it so its gold
  // star comes into view. nonce changes per request so re-selecting the same EGM
  // re-triggers the fly. prevSelectedToCompareRef lets us spot the single newly-added
  // slot; mapFocusNonceRef avoids needing functional updates inside the diff effect.
  const [mapFocusSlot, setMapFocusSlot] = useState<{
    slotNumber: number;
    nonce: number;
  } | null>(null);
  const prevSelectedToCompareRef = useRef<number[]>(selectedToCompare);
  const mapFocusNonceRef = useRef(0);
  // Set when a selection originates from a map-pin tap, so the fly-to-on-select
  // effect below leaves the camera where it is. List selections still fly.
  const suppressNextMapFocusRef = useRef(false);

  // Two-tap EGM name behaviour (drawerActionButtons flag): the first tap on a list
  // row's name flies the map to that EGM and is remembered here; a second tap on the
  // SAME EGM (while the map hasn't moved) opens its detail. Any user map move clears
  // this so the next tap re-centres instead of opening detail.
  const nameTapFocusedSlotRef = useRef<number | null>(null);
  const showDrawerFilters = React.useCallback(() => {
    setIsDrawerFiltersVisible(true);
  }, []);
  const handleMapUserMove = React.useCallback(() => {
    nameTapFocusedSlotRef.current = null;
    // After list scroll collapses filters, any user map pan/zoom/rotate restores them.
    showDrawerFilters();
  }, [showDrawerFilters]);

  /**
   * Explore map bank-label tap: same filter path as search "Bank 9G (n)".
   * Clears on retap of the active bank (no map/drawer move). Non-bank labels no-op.
   */
  const handleBankLabelClick = React.useCallback(
    (payload: { label: string; lngLat?: { lng: number; lat: number } | null }) => {
      const label = String(payload?.label ?? '').trim();
      if (!label || !casinoId) return;

      const applyDecision = (machines: NonNullable<ICasinoSearchData['data']>) => {
        const decision = decideBankLabelTap(label, machines, {
          selectedSlotsName,
          isBankFilter,
        });
        if (decision.type === 'noop') return;
        if (decision.type === 'clear') {
          clearBankFilter(slotCommands, slotCompareCommands);
          handleInputChange('slotnumbers', '');
          return;
        }

        applyBankFilter(
          slotCommands,
          slotCompareCommands,
          decision.match.displayLabel,
          decision.match.mnums
        );

        if (shouldRaiseDrawerForBankTap(currentSnapRef.current)) {
          setDrawerForceSnap(SnapPoint.Mid);
          window.setTimeout(() => setDrawerForceSnap(null), 100);
        }
      };

      if (casinoSearchData && casinoSearchData.casinoId === casinoId) {
        applyDecision(casinoSearchData.data ?? []);
        return;
      }

      // Fetch GetSearchData if not loaded yet; ignore result if casino changed.
      const requestedCasinoId = casinoId as number;
      if (searchDataFetchingForRef.current === requestedCasinoId) return;
      searchDataFetchingForRef.current = requestedCasinoId;
      casinoSvc.GetSearchData(requestedCasinoId).subscribe({
        next(resp) {
          searchDataFetchingForRef.current = null;
          if (!resp) return;
          const cleaned = resp.DataSet.map((item) => ({
            ...item,
            game_name: isInsightCardRow(item) ? item.game_name : getCleanGameName(item.game_name),
          }));
          casinoCommands.SetCasinoSearchData({
            casinoId: requestedCasinoId,
            data: cleaned,
          });
          applyDecision(cleaned);
        },
        error() {
          searchDataFetchingForRef.current = null;
        },
      });
    },
    [
      casinoId,
      casinoSearchData,
      selectedSlotsName,
      isBankFilter,
      slotCommands,
      slotCompareCommands,
      casinoSvc,
      casinoCommands,
    ]
  );

  // Detect a single newly-selected EGM and ask the map to fly to it. Bulk changes
  // (Select-All) and removals are ignored — only an unambiguous single add focuses.
  useEffect(() => {
    const prev = prevSelectedToCompareRef.current;
    const added = selectedToCompare.filter((n) => !prev.includes(n));
    prevSelectedToCompareRef.current = selectedToCompare;
    // A map-pin tap selects without moving the camera; consume the flag and bail.
    if (suppressNextMapFocusRef.current) {
      suppressNextMapFocusRef.current = false;
      return;
    }
    const addedRow = (playData || []).find((r) => matchesEgmDetailId(r, added[0]));
    if (added.length === 1 && (!isInsightCasino || canShowOnMap(addedRow, isMapless))) {
      mapFocusNonceRef.current += 1;
      setMapFocusSlot({ slotNumber: added[0], nonce: mapFocusNonceRef.current });
    }
  }, [selectedToCompare]);

  // Filter is engaged but the user has nothing saved to it. Used to show the
  // dedicated empty-state message, clear the map, and skip the list query.
  const isFavoritesEmptyState = isFavoritesActive && (!favoritesList || favoritesList.length === 0);
  const isPlaylistEmptyState = isPlaylistActive && (!playlist || playlist.length === 0);

  // When a Favorites/Playlist filter is active but nothing is saved, raise the
  // drawer so the full "is Empty" message is visible (there is no list to
  // scroll and the toolbar is hidden). One-shot so the user can still drag the
  // drawer back down afterwards.
  const isSavedFilterEmpty = isFavoritesEmptyState || isPlaylistEmptyState;
  useEffect(() => {
    if (!isSavedFilterEmpty) return;
    // Hold mode is the user-requested "stay put while I switch Insight/Timeframe"
    // position — don't override it even when the new filter is empty.
    if (currentSnap === SnapPoint.Hold) return;
    // Open to 50% so the empty Favorites/Playlist message is visible without
    // taking over the whole screen.
    setDrawerForceSnap(SnapPoint.Half);
    const timer = window.setTimeout(() => setDrawerForceSnap(null), 100);
    return () => window.clearTimeout(timer);
  }, [isSavedFilterEmpty]);

  // Filter is engaged WITH saved EGMs (not the empty state above).
  const hasSavedFavorites = isFavoritesActive && !!favoritesList && favoritesList.length > 0;
  const hasSavedPlaylist = isPlaylistActive && !!playlist && playlist.length > 0;

  // On a Jackpot insight the report only includes EGMs that hit a jackpot in the
  // timeframe, so when the user has saved EGMs but none of them returned jackpot
  // data the list comes back with no jackpot rows. Show a dedicated message
  // instead of an empty list (loading must be finished first).
  const isJackpotInsight = JACKPOT_MESSAGE_INSIGHTS.includes(tabSelectedInsight);
  const noJackpotRows =
    isJackpotInsight &&
    !isListReportLoading &&
    !isCasinoLoading &&
    !isSlotPlayDataIsLoading &&
    !visibleHotDataList.some((row) => Number(row?.jackpots) > 0);
  const isFavoritesNoJackpotState = hasSavedFavorites && noJackpotRows;
  const isPlaylistNoJackpotState = hasSavedPlaylist && noJackpotRows;

  // Show the Favorites/Playlist empty notice whenever the filter is engaged and
  // the report comes back with no rows. This covers both having nothing saved
  // AND having saved EGMs that are all filtered out of the current
  // insight/timeframe (nothing returned). The more specific jackpot message
  // takes precedence when it applies.
  const finishedLoading =
    !isListReportLoading && !isCasinoLoading && !isSlotPlayDataIsLoading;
  const showFavoritesEmptyNotice =
    isFavoritesActive && finishedLoading && visibleHotDataList.length === 0 && !isFavoritesNoJackpotState;
  const showPlaylistEmptyNotice =
    isPlaylistActive && finishedLoading && visibleHotDataList.length === 0 && !isPlaylistNoJackpotState;

  // Every EGM shown on the Favorites/Playlist filtered views is already saved to
  // that list, so the corresponding action pill removes the selected machines
  // instead of adding them: the heart pill becomes "Remove" while Favorites is
  // active, and the playlist pill becomes "Remove" while Playlist is active.
  const isFavoritesRemoveMode = isFavoritesActive;
  const isPlaylistRemoveMode = isPlaylistActive;

  // When every displayed EGM on a Favorites/Playlist view is selected the user
  // is emptying the entire list. The pill keeps its icon and bulk-remove
  // behavior, but relabels to "Empty Favorites" / "Empty Playlist" and moves to
  // sit after the Compare pill. Any partial selection keeps the "Remove" layout.
  // Membership (not just count) check: with the selection now persisting into a
  // Favorites/Playlist view, a coincidental count match must not flip the pill to
  // the destructive "Empty Favorites/Playlist" action against a non-matching set.
  const areAllSelected =
    selectedToCompare.length > 0 &&
    visibleHotDataList.length > 0 &&
    visibleHotDataList.every((d) => {
      const id = egmDetailId(d);
      return id !== null && selectedToCompare.includes(id);
    });
  const isFavoritesEmptyMode = isFavoritesActive && areAllSelected;
  const isPlaylistEmptyMode = isPlaylistActive && areAllSelected;

  // On a saved-list view (Favorites/Playlist) the drawer's select-all/clear box
  // is scoped to the EGMs shown in THAT list: its count and checkbox reflect only
  // the selected EGMs in this list, and select-all/clear add/remove just those —
  // preserving any selection the user built in other lists. (The floating
  // "Selected (#)" pill still shows the full cross-list working set.)
  const isListScopedSelect = isFavoritesActive || isPlaylistActive;
  // Title / Theme / Bank / search filter: Select All (not Top 10).
  const isSlotFilterActive = selectedSlots.length > 0;
  const useSelectAll = isListScopedSelect || isSlotFilterActive;
  const displayedSlotSet = useMemo(
    () =>
      new Set(
        visibleHotDataList.map((d) => egmDetailId(d)).filter((n): n is number => n !== null)
      ),
    [visibleHotDataList]
  );
  const selectBoxSelectedCount = isListScopedSelect
    ? selectedToCompare.filter((slot) => displayedSlotSet.has(slot)).length
    : selectedToCompare.length;

  // The action pills only render once a selection exists and the list has
  // finished loading. Track that as a single flag so it can drive both the JSX
  // and the height-measurement effect that keeps the sticky header docked
  // beneath the pinned pills.
  const showComparePills =
    selectedToCompare.length > 0 &&
    !isListReportLoading &&
    !isCasinoLoading &&
    !isSlotPlayDataIsLoading;

  // The hot-list table (column header + rows) is shown once loading has settled
  // and there is at least one row. Tracked as a single flag so the sticky head
  // and the rows below it stay in sync.
  const showHotDataTable =
    !isListReportLoading &&
    !isCasinoLoading &&
    !isSlotPlayDataIsLoading &&
    !isFavoritesNoJackpotState &&
    !isPlaylistNoJackpotState &&
    visibleHotDataList?.length > 0;

  useEffect(() => {
    if (isPlaylistEnabled && userId && casinoId) {
      fetchUserPlaylist(String(userId), String(casinoId));
    }
  }, [isPlaylistEnabled, userId, casinoId, fetchUserPlaylist]);

  useEffect(() => {
    if (userId && casinoId) {
      fetchUserFavorites(String(userId), String(casinoId));
    }
  }, [userId, casinoId, fetchUserFavorites]);


  const [isFooterVisible, setIsFooterVisible] = useState(true);
  // Insight + timeframe rows in the Hottest Slots drawer header. Hidden when the
  // EGM list scrolls down to reveal more cards; restored at top, after repeated
  // fast upward flicks, after EGM Details remount, or when the user pans/zooms/
  // taps the map. A single flick or medium reverse scroll keeps them hidden.
  const [isDrawerFiltersVisible, setIsDrawerFiltersVisible] = useState(true);
  const [mapBottomPadding, setMapBottomPadding] = useState(() => Math.round(window.innerHeight * 0.42));
  // True while the user is dragging the bottom drawer; hides the map recenter icon.
  const [isDrawerDragging, setIsDrawerDragging] = useState(false);
  const [bubbleWidth, setBubbleWidth] = useState(0);
  const bubbleRef = useRef<HTMLDivElement>(null);
  const previousScrollTopRef = useRef(0);
  // Recent scroll samples for mid-list flick velocity (px/ms over ~80ms).
  const drawerFiltersScrollSamplesRef = useRef<DrawerFiltersScrollSample[]>([]);
  // Distinct fast upward flicks toward the top (reset on down-scroll / window).
  const drawerFiltersFlickTrackerRef = useRef<DrawerFiltersFlickTracker>(createDrawerFiltersFlickTracker());
  // After a filters hide/show, ignore the opposite toggle until the CSS ease
  // finishes — except forced restores (top / programmatic / map). Matches the
  // soft footer slide so bounce can't snap the chips mid-animation.
  const filtersToggleCooldownUntilRef = useRef(0);
  const footerIdleTimerRef = useRef<number | null>(null);
  // Once scrolling stops, restore the footer after this long with no further
  // scroll activity (the timer is reset on every scroll event).
  const FOOTER_IDLE_TIMEOUT_MS = 5000;
  // While we programmatically scroll the list to a selected map pin's row
  // (see handleMapPinSelect), the resulting scroll events must NOT hide the
  // footer. Holds the timestamp (ms) until which footer-hide is suppressed.
  const suppressFooterHideUntilRef = useRef(0);
  // The EGM list's own scroll element (resolved lazily from the IonContent), used
  // to detect when the list is scrolled to the bottom. Cleared whenever the list
  // IonContent unmounts (EGM Details) so we never treat a detached node as live.
  const listContentRef = useRef<HTMLIonContentElement>(null);
  const listScrollElRef = useRef<HTMLElement | null>(null);

  const SHORTCUTS: Shortcut[] = [
    { id: 'all', label: 'All' },
    ...(featureFlags.hotColdShortcuts
      ? [
        { id: 'hottest', label: 'Hottest Slots' },
        { id: 'coldest', label: 'Coldest Slots' },
      ]
      : []),
    // Jackpots shortcut removed — users now pick the Jackpots insight from
    // the drawer's insight section instead.
    { id: 'favorites', label: 'Favorites' },
    ...(isPlaylistEnabled ? [{ id: 'playlist', label: 'Playlist' }] : []),
  ];

  const handleShortcutSelect = (shortcut: Shortcut) => {
    // Picking any list shortcut leaves the "Selected" review filter.
    setIsSelectedActive(false);
    // Switching the list filter (e.g. Favorites → Playlist) shows a different set
    // of EGMs. With the drawerActionButtons feature the selection is a casino-wide
    // working set that intentionally persists across All/Favorites/Playlist, so
    // only clear it when that flag is off (legacy behaviour: reset the multi-select
    // so the action pill doesn't linger over the new view).
    if (!featureFlags.drawerActionButtons && selectedToCompare.length > 0) {
      slotCompareCommands.clearSlots();
    }
    // Selecting a shortcut pill from the EGM detail drawer should return the user
    // to the casino home list filtered for that pill — close the open detail view first.
    if (activeSlotNumber) {
      clearSlotHistory();
    }
    // Clear favorites filter when switching to any other shortcut
    if (shortcut.id !== 'favorites' && isFavoritesActive) {
      setIsFavoritesActive(false);
      handleInputChange('slotnumbers', '');
      handleInputChange('pageNumber', 0);
    }
    // Clear playlist filter when switching to any other shortcut
    if (shortcut.id !== 'playlist' && isPlaylistActive) {
      setIsPlaylistActive(false);
      handleInputChange('slotnumbers', '');
      handleInputChange('pageNumber', 0);
    }
    if (shortcut.id === 'all') {
      // Clear all active filters and reset to the Explore default insight
      // (Desc) over the exploreDefaultTimeframe (lib/exploreDefaults; fallback
      // Hottest Slots + 7 days), showing ALL EGMs. As before this MR, All uses
      // the non-insight-casino timeframe for every casino (an insight casino's
      // timeframe sync maps 7d to its own 7d id).
      setIsFavoritesActive(false);
      setIsPlaylistActive(false);
      const allTimeframe = getExploreDefaultTimeframe(false);
      filterCommandCreator.SetFilterOptions(tabSelected, {
        insight: exploreDefaults.insight,
        timeframe: allTimeframe,
        orderby: exploreDefaults.orderby,
      });
      setCasinoParams((prev) => ({
        ...prev,
        insight: exploreDefaults.insight,
        timeframe: legacyTimeframeId(allTimeframe),
        orderby: exploreDefaults.orderby,
        slotnumbers: '',
        pageNumber: 0,
      }));
      commands.SetSlotOrderState(true);
      // Match the casino-entry default heat-map filter (top heat levels for the
      // Hottest view) and sync prevInsightRef so the insight-change effect
      // doesn't flip it back to "show all".
      prevInsightRef.current = exploreDefaults.insight;
      floormapCommand.SetDefaultHeatFilterAction(getHeatFilterForSortDirection(
        exploreDefaults.insight,
        exploreDefaults.orderby
      ));
      return;
    } else if (shortcut.id === 'hottest') {
      filterCommandCreator.SetFilterOptions(tabSelected, {
        insight: InsightValueEnum.return,
        timeframe: TimeFrameValueEnum.months1,
        orderby: OrderByEnum.Desc,
      });
      commands.SetSlotOrderState(true);
      setCasinoParams((prev) => ({ ...prev, insight: InsightValueEnum.return, orderby: OrderByEnum.Desc, pageNumber: 0 }));
      // Show only top 2 heat levels (hottest) on the map
      floormapCommand.SetDefaultHeatFilterAction([5, 4]);
    } else if (shortcut.id === 'coldest') {
      filterCommandCreator.SetFilterOptions(tabSelected, {
        insight: InsightValueEnum.return,
        timeframe: TimeFrameValueEnum.months1,
        orderby: OrderByEnum.Asc,
      });
      commands.SetSlotOrderState(false);
      setCasinoParams((prev) => ({ ...prev, insight: InsightValueEnum.return, orderby: OrderByEnum.Asc, pageNumber: 0 }));
      // Show only bottom 2 heat levels (coldest) on the map
      floormapCommand.SetDefaultHeatFilterAction([2, 1]);
    } else if (shortcut.id === 'favorites') {
      if (isFavoritesActive) {
        // Deselect — clear slot filter
        setIsFavoritesActive(false);
        handleInputChange('slotnumbers', '');
        handleInputChange('pageNumber', 0);
      } else {
        // Select — filter to favorited slot numbers using current insight
        setIsFavoritesActive(true);
        const favSlotNumbers = favoritesList.map((f: any) => f.slotNumber).join(',');
        handleInputChange('slotnumbers', favSlotNumbers);
        handleInputChange('pageNumber', 0);
      }
      // Reset heat filter to show all levels
      floormapCommand.SetDefaultHeatFilterAction(heatLegendAllInsight);
    } else if (shortcut.id === 'playlist') {
      if (isPlaylistActive) {
        setIsPlaylistActive(false);
        handleInputChange('slotnumbers', '');
        handleInputChange('pageNumber', 0);
      } else {
        setIsPlaylistActive(true);
        const playlistSlotNumbers = (playlist || []).map((p) => p.slotNumber).join(',');
        handleInputChange('slotnumbers', playlistSlotNumbers);
        handleInputChange('pageNumber', 0);
      }
      floormapCommand.SetDefaultHeatFilterAction(heatLegendAllInsight);
    }
  };

  // Toggle the "Selected" review filter: narrow both the list AND the map to the
  // EGMs currently selected, or return to the default All view. Selecting EGMs
  // spans All/Favorites/Playlist, so this lets the user review the working set.
  // While active the map plots only the selected EGMs, numbering every one of them
  // (see mapFilterSlotNumbers/showAllMarkers below).
  const handleViewSelected = () => {
    if (isSelectedActive) {
      handleShortcutSelect({ id: 'all', label: 'All' });
      return;
    }
    if (selectedToCompare.length === 0) return;
    setIsSelectedActive(true);
    setIsFavoritesActive(false);
    setIsPlaylistActive(false);
    handleInputChange('slotnumbers', selectedToCompare.join(','));
    handleInputChange('pageNumber', 0);
    floormapCommand.SetDefaultHeatFilterAction(heatLegendAllInsight);
  };

  // While the Selected filter is active, keep both the list and the map locked to
  // the live selection: whenever the user adds/removes an EGM the filter's slot
  // numbers re-sync, which refetches the list and re-pins (and renumbers) the map
  // to the new set. If the selection empties (every row deselected) drop back to
  // the default All view so the list isn't stuck on a stale set.
  useEffect(() => {
    if (!isSelectedActive) return;
    if (selectedToCompare.length === 0) {
      setIsSelectedActive(false);
      handleInputChange('slotnumbers', '');
      handleInputChange('pageNumber', 0);
      return;
    }
    const nextSlotNumbers = selectedToCompare.join(',');
    if (casinoParams.slotnumbers !== nextSlotNumbers) {
      handleInputChange('slotnumbers', nextSlotNumbers);
      handleInputChange('pageNumber', 0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSelectedActive, selectedToCompare]);

  const activeShortcutId = (() => {
    if (isSelectedActive) return '';
    if (isFavoritesActive) return 'favorites';
    if (isPlaylistActive) return 'playlist';
    if (featureFlags.hotColdShortcuts && tabSelectedInsight === InsightValueEnum.return) {
      if (casinoParams.orderby === OrderByEnum.Desc) return 'hottest';
      if (casinoParams.orderby === OrderByEnum.Asc) return 'coldest';
    }
    return 'all';
  })();

  // A "cold" view is any non-jackpot insight sorted ascending — the same signal
  // getHeatFilterForSortDirection uses to default the map to the bottom 2 tiers
  // ([2,1]). The heat-ledge sun mirrors this: when all colors are selected, its
  // narrow action focuses the bottom 2 colors instead of the top 2.
  const isColdSortView =
    casinoParams.orderby === OrderByEnum.Asc &&
    !JACKPOT_INSIGHTS.includes(casinoParams.insight);

  useEffect(() => {
    if (!isPlaylistActive) return;
    if (!playlist || playlist.length === 0) {
      // Keep the filter engaged so the empty-state message shows.
      handleInputChange('slotnumbers', '');
      handleInputChange('pageNumber', 0);
      return;
    }
    const playlistSlotNumbers = playlist.map((p) => p.slotNumber).join(',');
    handleInputChange('slotnumbers', playlistSlotNumbers);
    handleInputChange('pageNumber', 0);
  }, [playlist, isPlaylistActive]);

  useEffect(() => {
    if (!isFavoritesActive) return;
    if (!favoritesList || favoritesList.length === 0) {
      // Keep the filter engaged so the empty-state message shows.
      handleInputChange('slotnumbers', '');
      handleInputChange('pageNumber', 0);
      return;
    }
    const favSlotNumbers = favoritesList.map((f: any) => f.slotNumber).join(',');
    handleInputChange('slotnumbers', favSlotNumbers);
    handleInputChange('pageNumber', 0);
  }, [favoritesList, isFavoritesActive]);

  // Guard so ionInfinite cannot stack page bumps while a fetch is in flight
  // (bottom bounce + 100px threshold used to re-fire before .complete()).
  const isFetchingMoreRef = useRef(false);

  // Stable list order (display-only): the sort + scope of the list on screen.
  // Data that arrives for the same sort/scope (next page, a cached-then-network
  // second emission, a page-0 refetch from an unrelated pageNumber reset) is
  // merged with appendWithoutReorder instead of replacing the shown cards.
  // Only a different sort/scope (sort icon/shortcut, timeframe, filter,
  // casino) loads a freshly sorted list. See lib/stableEgmListOrder.ts.
  const shownListScopeRef = useRef<string>('');
  const egmListRowKey = (row: ICasinoReport): string => {
    const id = egmDetailKey(row);
    if (id) return id;
    const loc = row?.slot_number;
    return loc === null || loc === undefined || String(loc).trim() === '' ? '' : `loc:${String(loc).trim()}`;
  };

  const handleFetchMore = (): void => {
    if (isEndReached || isFetchingMoreRef.current || isListReportLoading) {
      void ionInfiniteScrollRef.current?.complete();
      return;
    }
    isFetchingMoreRef.current = true;
    handleInputChange(
      'pageNumber',
      nextListPageNumber(casinoParams.pageNumber, hotDataList ? hotDataList.length : 0, itemsPerPage)
    );
  };

  const emitFooterVisibility = useCallback((visible: boolean) => {
    setIsFooterVisible(visible);
    window.dispatchEvent(
      new CustomEvent<FooterVisibilityEventDetail>(FOOTER_VISIBILITY_EVENT, {
        detail: { visible },
      })
    );
  }, []);

  const resetFooterIdleTimer = useCallback(() => {
    if (footerIdleTimerRef.current) {
      window.clearTimeout(footerIdleTimerRef.current);
    }
    footerIdleTimerRef.current = window.setTimeout(() => {
      emitFooterVisibility(true);
    }, FOOTER_IDLE_TIMEOUT_MS);
  }, [emitFooterVisibility]);

  // Measure the search bubble width dynamically so ShortcutBar can offset exactly
  useEffect(() => {
    const el = bubbleRef.current;
    if (!el) return;
    let rafId = 0;
    const observer = new ResizeObserver((entries) => {
      if (rafId) return;
      rafId = requestAnimationFrame(() => {
        rafId = 0;
        const width =
          entries[0]?.borderBoxSize?.[0]?.inlineSize ?? entries[0]?.contentRect?.width ?? 0;
        const next = width > 0 ? Math.round(width) + 20 : 0;
        setBubbleWidth((prev) => (prev === next ? prev : next));
      });
    });
    observer.observe(el);
    return () => {
      if (rafId) cancelAnimationFrame(rafId);
      observer.disconnect();
    };
  }, [bubbleRef.current]);

  const handleDrawerTranslateY = useCallback((panelTop: number) => {
    setMapBottomPadding(Math.max(0, window.innerHeight - panelTop));
  }, []);

  const handleDrawerPanelScroll = useCallback(
    (scrollTop: number, atBottom = false) => {
      const currentScrollTop = Math.max(0, scrollTop);
      const delta = currentScrollTop - previousScrollTopRef.current;
      const nowMs = Date.now();
      const suppressProgrammatic = nowMs < suppressFooterHideUntilRef.current;

      // Near-bottom uses a wider band than hard atBottom so the footer stays
      // pinned before the end stop — avoiding a ±tab-bar maxHeight jump that
      // stutters the last rows. Bottom also freezes filter toggles.
      const nearOrAtBottom = atBottom;

      let repeatedFlicksReady = false;
      if (!nearOrAtBottom) {
        const samples = drawerFiltersScrollSamplesRef.current;
        samples.push({ scrollTop: currentScrollTop, timeMs: nowMs });
        pruneScrollSamples(samples, nowMs);
        const upwardVelocityPxPerMs = computeUpwardScrollVelocityPxPerMs(samples, nowMs);
        const flickCount = updateDrawerFiltersFlickTracker({
          tracker: drawerFiltersFlickTrackerRef.current,
          upwardVelocityPxPerMs,
          scrollDelta: delta,
          nowMs,
        });
        repeatedFlicksReady = flickCount >= DRAWER_FILTERS_FLICKS_TO_REVEAL;
      } else {
        // Bounce reverse at the end must not accumulate toward a flick reveal.
        drawerFiltersFlickTrackerRef.current = createDrawerFiltersFlickTracker();
        drawerFiltersScrollSamplesRef.current = [{ scrollTop: currentScrollTop, timeMs: nowMs }];
      }

      // Insight/timeframe decision runs BEFORE footer early-returns so a stale
      // atBottom (detached IonContent scroll el after EGM Details → back) cannot
      // block top restore. atBottom freezes mid-list hide/show inside decide().
      const filtersDecision = decideDrawerFiltersVisibility({
        scrollTop: currentScrollTop,
        previousScrollTop: previousScrollTopRef.current,
        filtersVisible: isDrawerFiltersVisible,
        suppressProgrammaticScroll: suppressProgrammatic,
        repeatedFlicksReady,
        atBottom: nearOrAtBottom,
      });
      // Show always applies (top / repeated flicks / map / after Details). Hide
      // waits out the CSS ease after a recent show so bounce can't snap chips.
      const filtersHideCooldownActive = nowMs < filtersToggleCooldownUntilRef.current;
      if (filtersDecision.action === 'show') {
        setIsDrawerFiltersVisible(true);
        filtersToggleCooldownUntilRef.current = nowMs + DRAWER_FILTERS_TOGGLE_COOLDOWN_MS;
        drawerFiltersFlickTrackerRef.current = createDrawerFiltersFlickTracker();
      } else if (filtersDecision.action === 'hide' && !filtersHideCooldownActive) {
        setIsDrawerFiltersVisible(false);
        filtersToggleCooldownUntilRef.current = nowMs + DRAWER_FILTERS_TOGGLE_COOLDOWN_MS;
        drawerFiltersFlickTrackerRef.current = createDrawerFiltersFlickTracker();
      }

      // Programmatic jump to a single-tapped map pin's row: keep the footer
      // visible and don't let the auto-scroll register as a "scroll down".
      if (suppressProgrammatic) {
        previousScrollTopRef.current = currentScrollTop;
        if (!isFooterVisible) emitFooterVisibility(true);
        resetFooterIdleTimer();
        return;
      }

      // At/near the bottom of the EGM list the footer always stays visible: keep
      // it shown and don't let overscroll/momentum at the very end register as a
      // scroll-down that would hide it (and resize the panel). Filters are frozen
      // above so bounce reverse cannot expand the toolbar here either.
      if (nearOrAtBottom) {
        previousScrollTopRef.current = currentScrollTop;
        if (!isFooterVisible) emitFooterVisibility(true);
        resetFooterIdleTimer();
        return;
      }

      // Ignore sub-threshold movement so iOS overscroll "bounce" at the list
      // ends (which makes scrollTop jitter back and forth) can't flicker the
      // footer. The anchor (previousScrollTopRef) is left untouched below the
      // threshold so slow scrolls still accumulate into a real direction.
      const SCROLL_DIRECTION_THRESHOLD = 4;
      if (Math.abs(delta) < SCROLL_DIRECTION_THRESHOLD) {
        resetFooterIdleTimer();
        return;
      }

      if (delta > 0 && isFooterVisible) {
        emitFooterVisibility(false);
      } else if (delta < 0 && !isFooterVisible) {
        emitFooterVisibility(true);
      }

      previousScrollTopRef.current = currentScrollTop;
      resetFooterIdleTimer();
    },
    [
      emitFooterVisibility,
      isFooterVisible,
      isDrawerFiltersVisible,
      resetFooterIdleTimer,
    ]
  );

  // Fast-scroll the EGM list back to the first record. Wired to a double-tap on
  // the drawer header (see ResultsToolbar / ListSheet onHeaderDoubleTap).
  const handleScrollListToTop = useCallback(() => {
    void listContentRef.current?.scrollToTop(250);
  }, []);

  useEffect(() => {
    resetFooterIdleTimer();

    return () => {
      if (footerIdleTimerRef.current) {
        window.clearTimeout(footerIdleTimerRef.current);
      }
      emitFooterVisibility(true);
    };
  }, [emitFooterVisibility, resetFooterIdleTimer]);

  const fetchPlayDataReport = (queryParams: IRequestCasinoParams): Subscription => {
    setSlotPlayDataIsLoading(true);
    // Drop slotnumbers from the map request. GetPlayDataReport ignores it
    // server-side (the map plots the full floor and narrows client-side via
    // mapSlotData), so sending it is pointless — and for a large challenge the
    // full EGM CSV blows up the GET URL past the gateway's length limit, which
    // fails the CORS preflight (ERR_NETWORK) and fires the report-error toast.
    const { limit, pageNumber, compareSlotNumbers, slotnumbers, ...rest } = queryParams;
    const restParam = { ...rest, slot: 0 };

    return casinoSvc.GetPlayDataReport(restParam).subscribe({
      next(casinoResponse) {
        if (casinoResponse) {
          setPlayData(casinoResponse.DataSet);
        }
      },
      error(_err) {
        setSlotPlayDataIsLoading(false);
        presentToast({
          position: 'top',
          duration: 5000,
          color: 'danger',
          message: 'Failed to retrieve casino report.',
        }).catch(() => null);
        ionInfiniteScrollRef.current?.complete();
      },
      complete() {
        setSlotPlayDataIsLoading(false);
      },
    });
  };

  const fetchListReport = (queryParams: IRequestCasinoParams): Subscription => {
    // Decided once per request: does this response belong to the list already
    // on screen (same sort + scope)? Then it is merged without reordering and
    // without the loading state (which unmounts the rows and resets scroll).
    const requestScope = listSortScopeKey(queryParams);
    const isSameShownList =
      shownListScopeRef.current !== '' && shownListScopeRef.current === requestScope;
    if (queryParams.pageNumber === 0) {
      if (!isSameShownList) {
        setListReportLoading(true);
        setIsEndReached(false);
      }
      isFetchingMoreRef.current = false;
    }
    // In challenge mode the assigned-EGM set can exceed the gateway's ~2KB
    // query-string limit (AWS WAF SizeRestrictions_QUERYSTRING) when sent as the
    // slotnumbers param, which fails the CORS preflight (ERR_NETWORK) in prod.
    // Instead fetch the full floor in one page (no slotnumbers) and narrow to the
    // challenge's slots client-side. Whole-floor loads mean infinite scroll is a
    // no-op here (isEndReached becomes true once totalCount == the filtered set).
    const challengeSlots =
      challengeName && selectedSlots.length > 0 ? selectedSlots.map(String) : null;
    const requestParams: IRequestCasinoParams = challengeSlots
      ? { ...queryParams, slotnumbers: '', pageNumber: 0, limit: CHALLENGE_FULL_FLOOR_LIMIT }
      : queryParams;
    return casinoSvc.ListReport(requestParams).subscribe({
      next(casinoResponse) {
        if (casinoResponse) {
          if (challengeSlots) {
            const allowed = new Set(challengeSlots);
            const filtered = (casinoResponse.DataSet || []).filter((row) => {
              const id = egmDetailId(row);
              return id !== null && allowed.has(String(id));
            });
            if (isSameShownList) {
              setHotDataList((prevItems) =>
                appendWithoutReorder(prevItems, filtered, egmListRowKey)
              );
            } else {
              setHotDataList(filtered);
            }
            shownListScopeRef.current = filtered.length > 0 ? requestScope : '';
            setTotalCount(filtered.length);
            setIsEndReached(true);
          } else {
            const page = casinoResponse.DataSet || [];
            const total = casinoResponse.totalCount || 0;
            // A page for a list that is no longer on screen (sort/scope changed
            // while it was in flight) must not be appended to the new list.
            if (queryParams.pageNumber !== 0 && !isSameShownList) {
              isFetchingMoreRef.current = false;
              void ionInfiniteScrollRef.current?.complete();
              return;
            }
            setTotalCount(total);
            if (queryParams.pageNumber === 0 && !isSameShownList) {
              // New sort/scope: the one place the list takes a freshly sorted order.
              setHotDataList(page);
              shownListScopeRef.current = page.length > 0 ? requestScope : '';
              setIsEndReached(
                shouldEndInfiniteScroll({
                  loadedCount: page.length,
                  totalCount: total,
                  pageLength: page.length,
                  pageSize: itemsPerPage,
                })
              );
            } else {
              // Added data for the list on screen: keep the shown cards' order,
              // refresh their values in place, append new EGMs at the end.
              setHotDataList((prevItems) => {
                const next = appendWithoutReorder(prevItems, page, egmListRowKey);
                setIsEndReached(
                  shouldEndInfiniteScroll({
                    loadedCount: next.length,
                    totalCount: total,
                    pageLength: page.length,
                    pageSize: itemsPerPage,
                  })
                );
                return next;
              });
            }
          }
        }
        isFetchingMoreRef.current = false;
        void ionInfiniteScrollRef.current?.complete();
      },
      error(_err) {
        setListReportLoading(false);
        setCasinoLoading(false);
        isFetchingMoreRef.current = false;
        presentToast({
          position: 'top',
          duration: 5000,
          color: 'danger',
          message: 'Failed to retrieve casino report.',
        }).catch(() => null);
        void ionInfiniteScrollRef.current?.complete();
      },
      complete() {
        setListReportLoading(false);
        setCasinoLoading(false);
        isFetchingMoreRef.current = false;
      },
    });
  };

  const memoizedCasinoParams = useMemo(() => {
    if (casinoParams.casinofk) {
      return casinoParams;
    } else {
      history.push('/auth/choosecasinos');
      return casinoParams;
    }
  }, [
    casinoParams.casinofk,
    casinoParams.insight,
    casinoParams.timeframe,
    casinoParams.slot,
    casinoParams.slotnumbers,
    casinoParams.compareSlotNumbers,
    casinoParams.orderby,
    casinoParams.pageNumber,
  ]);

  useEffect(() => {
    if (memoizedCasinoParams.slot != 0) return;

    // Favorites/Playlist filter is on but the user has nothing saved: keep the
    // list empty so the dedicated message shows instead of querying all slots.
    if (isFavoritesEmptyState || isPlaylistEmptyState) {
      setHotDataList([]);
      shownListScopeRef.current = '';
      setTotalCount(0);
      setListReportLoading(false);
      return;
    }

    const listReportSubscription = fetchListReport(memoizedCasinoParams);
    return () => {
      listReportSubscription.unsubscribe();
    };
  }, [memoizedCasinoParams, isFavoritesEmptyState, isPlaylistEmptyState]);

  useEffect(() => {
    if (isFavoritesEmptyState || isPlaylistEmptyState) {
      setPlayData(EMPTY_MAP_SLOT_DATA);
      return;
    }
    const playDataReportSubscription = fetchPlayDataReport(memoizedCasinoParams);
    return () => {
      playDataReportSubscription.unsubscribe();
    };
  }, [
    memoizedCasinoParams.casinofk,
    memoizedCasinoParams.insight,
    memoizedCasinoParams.timeframe,
    // memoizedCasinoParams.slot,
    memoizedCasinoParams.slotnumbers,
    memoizedCasinoParams.compareSlotNumbers,
    memoizedCasinoParams.orderby,
    isFavoritesEmptyState,
    isPlaylistEmptyState,
  ]);

  useEffect(() => {
    // Filtering by Game Name/Theme (a search selection, not a floor-map bank
    // filter) refreshes the report back to its defaults: the Explore default
    // insight over the exploreDefaultTimeframe (lib/exploreDefaults; fallback
    // Hottest Slots (RTP) over 7 days, as before).
    // insightInstance === 1 only: typed search is an extra filter on top of the
    // current insight/timeframe — do not reset those filters while the user types.
    // Any other insightInstance (or none) keeps today's reset-on-search behavior.
    const useInsightSearch = isInsightSearchInstance(casinoSchema?.insightInstance);
    const isGameOrThemeFilter = selectedSlots.length > 0 && !isBankFilter;
    const shouldResetInsightTimeframe = isGameOrThemeFilter && !useInsightSearch;
    const resetTimeframe = getExploreDefaultTimeframe(false);
    if (shouldResetInsightTimeframe) {
      filterCommandCreator.SetFilterOptions(tabSelected, {
        insight: exploreDefaults.insight,
        timeframe: resetTimeframe,
      });
    }

    const nextInsight = shouldResetInsightTimeframe ? exploreDefaults.insight : tabSelectedInsight;
    handleInputChange('insight', nextInsight);
    if (selectedSlots.length > 0) {
      // A Game Name/Title/Search selection supersedes the Favorites/Playlist/
      // Selected filter — clear those flags so the map and list stop limiting to
      // the saved slot numbers and instead honor the newly selected slots.
      setIsFavoritesActive(false);
      setIsPlaylistActive(false);
      setIsSelectedActive(false);
      handleInputChange('slotnumbers', selectedSlots.join(','));
    } else if (!isFavoritesActive && !isPlaylistActive) {
      handleInputChange('slotnumbers', '');
    }
    if (shouldResetInsightTimeframe) {
      handleInputChange('timeframe', legacyTimeframeId(resetTimeframe));
    }
    setActiveInsightFilter(nextInsight);
    handleInputChange('pageNumber', 0);
  }, [selectedSlots]);

  // Details open/close must NOT touch casinoParams.slot / pageNumber or remount
  // the list — that used to refetch GetCasinoInsights and wipe scroll/selection.
  // The drawer list stays mounted (hidden) under Details; Explore cache is reused.
  useEffect(() => {
    handleInputChange('insight', tabSelectedInsight);
    setActiveInsightFilter(tabSelectedInsight);
  }, [activeSlotNumber, tabSelectedInsight]);

  useEffect(() => {
    handleInputChange('insight', tabSelectedInsight);
    if (isComparing) {
      handleInputChange('compareSlotNumbers', compareSlots ? compareSlots.join(',') : '');
    } else {
      handleInputChange('compareSlotNumbers', '');
    }
    setActiveInsightFilter(tabSelectedInsight);
    handleInputChange('pageNumber', 0);
  }, [compareSlots]);
  useEffect(() => {
    handleInputChange('insight', tabSelectedInsight);
    handleInputChange('casinofk', casinoSchema?.kpCasinoPk);
    setActiveInsightFilter(tabSelectedInsight);
    handleInputChange('pageNumber', 0);
    // setTotalReportCount(0);
  }, [casinoSchema?.kpCasinoPk]);

  useEffect(() => {
    if (isInsightCasino) {
      // Insight casinos: a tab changed outside the list header (which already
      // synced casinoParams) also opens DESC, so its heat filter resets to the
      // top 2 instead of inheriting Coldest's ASC.
      setCasinoParams((prev) =>
        prev.insight === tabSelectedInsight
          ? prev
          : { ...prev, insight: tabSelectedInsight, orderby: OrderByEnum.Desc }
      );
    } else {
      handleInputChange('insight', tabSelectedInsight);
    }
    setActiveInsightFilter(tabSelectedInsight);
    handleInputChange('pageNumber', 0);
  }, [tabSelectedInsight]);

  // On insight change: reset heat map to show all first, then apply sort-based filter after data loads.
  // This gives the map a chance to draw fully before narrowing the visible heat levels.
  useEffect(() => {
    if (prevInsightRef.current !== tabSelectedInsight) {
      prevInsightRef.current = tabSelectedInsight;
      // Show all heat levels while data is loading so the map draws completely.
      const visibleAll = JACKPOT_INSIGHTS.includes(tabSelectedInsight)
        ? heatLegendJackpots
        : heatLegendAllInsight;
      floormapCommand.SetDefaultHeatFilterAction(visibleAll);
      // The post-load effect below will apply the sort-based filter once loading finishes.
    }
  }, [tabSelectedInsight]);

  // After data finishes loading, apply sort-direction-based heat filter.
  const wasLoadingRef = useRef(false);
  const isDataLoading = isSlotPlayDataIsLoading || isCasinoLoading;
  useEffect(() => {
    if (wasLoadingRef.current && !isDataLoading) {
      // Data just finished loading — apply the sort-direction heat filter.
      const filter = getHeatFilterForSortDirection(casinoParams.insight, casinoParams.orderby);
      floormapCommand.SetDefaultHeatFilterAction(filter);
    }
    wasLoadingRef.current = isDataLoading;
  }, [isDataLoading]);

  // Insight casinos only: the cached insight response never flips the loading
  // flag, so re-apply the Hot/Cold filter on every sort/tab/data change.
  useEffect(() => {
    const filter = getInsightHeatFilterReset({
      isInsightCasino,
      isDataLoading,
      hasData: !!playData,
      insight: casinoParams.insight,
      orderby: casinoParams.orderby,
    });
    if (filter) floormapCommand.SetDefaultHeatFilterAction(filter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isInsightCasino, isDataLoading, playData, casinoParams.insight, casinoParams.orderby, tabSelectedTimeframe]);

  useEffect(() => {
    // Insight casinos: map the selected value through the insight list so 4h/8h
    // send their own ids (never a legacy/current-hour id or undefined).
    if (isInsightCasino) {
      if (skipTimeframeSyncRef.current) {
        skipTimeframeSyncRef.current = false;
        return;
      }
      // A timeframe insight casinos don't offer (e.g. SLJ) maps to the Explore
      // default (same as the coercion effect above), not the resolver's 24h.
      const nextId = resolveInsightTimeframe(
        isInsightTimeframeValue(tabSelectedTimeframe) ? tabSelectedTimeframe : exploreDefaults.timeframe
      ).id;
      setCasinoParams((prev) => {
        if (prev.timeframe === nextId && prev.pageNumber === 0) return prev;
        return { ...prev, timeframe: nextId, pageNumber: 0 };
      });
      return;
    }
    const filterTime = config.allTimeFrames.filter(
      (timeframe) => timeframe.value === tabSelectedTimeframe
    )[0];
    handleInputChange('timeframe', filterTime.id);
    handleInputChange('pageNumber', 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tabSelectedTimeframe, isInsightCasino]);

  const getSortIcon = (column: string): JSX.Element | null => {
    if (column === casinoParams.insight) {
      return casinoParams.orderby === OrderByEnum.Asc ? (
        <FontAwesomeIcon icon={faCaretUp} className="sort-arrow-insights insight-name-sort-icon" />
      ) : (
        <FontAwesomeIcon
          icon={faCaretDown}
          className="sort-arrow-insights insight-name-sort-icon"
        />
      );
    }
    return null;
  };

  const handleSortChange = (column: string) => {
    if (column != 'game_name') {
      const insightWasChanged = tabSelectedInsight !== column;
      if (insightWasChanged) {
        filterCommandCreator.SetFilterOptions(tabSelected, {
          insight: column as InsightValue,
        });
      }
    }
    setCasinoLoading(true);

    setCasinoParams((prevParams) => {
      // Re-clicking the column that's already sorted flips its direction, so the
      // sort-arrow toggles between ascending and descending.
      //
      // Selecting a different insight sorts highest-first (DESC) so the strongest
      // EGMs for that metric lead. The only exception is the Coldest view —
      // which is defined by ascending order — where insight clicks keep
      // sorting lowest-first (ASC).
      // Insight casinos: a new tab always opens DESC (see getOrderbyForSortChange).
      const newOrderby = getOrderbyForSortChange({
        isInsightCasino,
        prevInsight: prevParams.insight,
        prevOrderby: prevParams.orderby,
        nextInsight: column,
        activeShortcutId,
      });
      const updatedParams = {
        ...prevParams,
        pageNumber: 0,
        insight: column,
        orderby: newOrderby,
      };
      commands.SetSlotOrderState(newOrderby === OrderByEnum.Desc);

      // Sort direction controls the heat lifter: set appropriate heat filter immediately.
      // Show all first while loading, post-load effect will apply the sort-based filter.
      const visibleAll = JACKPOT_INSIGHTS.includes(column)
        ? heatLegendJackpots
        : heatLegendAllInsight;
      floormapCommand.SetDefaultHeatFilterAction(visibleAll);

      return updatedParams;
    });
  };

  const getHotListReportBackgroundImage = (casinoName?: string) => {
    const name = casinoName?.toLowerCase();
    const backgroundNames: Record<string, string> = {
      lotc: 'report-bg-lotc.png',
      rwc: 'report-bg-rwc.png',
      ssc: 'report-bg-ssc.png',
    };
    const fileName = backgroundNames[name ?? ''] || 'report-bg-lotc.png';
    return `assets/images/${fileName}`;
  };

  const isExploreV2 = featureFlags.getThemeVersion() !== 'v1';

  useEffect(() => {
    if (!isExploreV2 || tabSelectedInsight !== 'return' || !casinoParams.casinofk) {
      return;
    }

    const subscription = casinoSvc
      .GetTrendsListDataReport({ casinoFk: casinoParams.casinofk, insightFilter: '{2}' })
      .pipe(catchError(() => of(null)))
      .subscribe((response) => {
        if (response && response.DataSet && response.DataSet.length > 0) {
          setTrendComparisonMap(response.DataSet);
        }
      });

    return () => {
      subscription.unsubscribe();
    };
  }, [casinoParams.casinofk, casinoSvc, tabSelectedInsight, isExploreV2]);

  // The EGM action pills (Compare / Favorites / Playlist), built once so they can
  // render either inside the drawer's sticky head (default) or, when the
  // drawerActionButtons flag is on, floating above the drawer (passed to ListSheet).
  const actionPills = showComparePills ? (
    <CompareView
      selectedSlots={selectedToCompare}
      isCompare={isComparing}
      showSelectedButton={featureFlags.drawerActionButtons}
      selectedCount={selectedToCompare.length}
      isSelectedView={isSelectedActive}
      onViewSelected={handleViewSelected}
      onClearSelected={() => slotCompareCommands.clearSlots()}
      showAddToFavorites={!!userId}
      favoritesActionLabel={
        isFavoritesEmptyMode ? 'Empty Favorites' : isFavoritesRemoveMode ? 'Remove' : 'Add'
      }
      moveFavoritesAfterCompare={isFavoritesEmptyMode}
      onAddToFavorites={() => {
        if (isFavoritesEmptyMode) {
          // "Empty Favorites" clears the ENTIRE list. Select Top 10 only
          // captures the top rows (capped at SELECT_TOP_LIMIT), so
          // removing selectedToCompare would leave the rest behind.
          // Remove every saved favorite so the slotNumbers array empties.
          const allFavorites = (favoritesList || []).map((f: any) => String(f.slotNumber));
          if (allFavorites.length === 0) return;
          handleDeleteFavoriteBulk(allFavorites, String(userId), String(casinoId));
          slotCompareCommands.clearSlots();
          return;
        }
        if (isFavoritesRemoveMode) {
          const toRemove = selectedToCompare
            .filter((slot) => isIncludedInFavorites(String(slot), favoritesList))
            .map((slot) => String(slot));
          if (toRemove.length === 0) return;
          handleDeleteFavoriteBulk(toRemove, String(userId), String(casinoId));
          slotCompareCommands.clearSlots();
          return;
        }
        const toAdd = selectedToCompare
          .filter((slot) => !isIncludedInFavorites(String(slot), favoritesList))
          .map((slot) => String(slot));
        if (toAdd.length === 0) return;
        handleInsertFavoriteBulk(toAdd, String(userId), String(casinoId));
      }}
      showAddToPlaylist={isPlaylistEnabled && !!userId && !!casinoId}
      playlistActionLabel={
        isPlaylistEmptyMode ? 'Empty Playlist' : isPlaylistRemoveMode ? 'Remove' : 'Add'
      }
      movePlaylistAfterCompare={isPlaylistEmptyMode}
      onAddToPlaylist={() => {
        if (isPlaylistEmptyMode) {
          // "Empty Playlist" clears the ENTIRE list. Select Top 10 only
          // captures the top rows (capped at SELECT_TOP_LIMIT), so
          // removing selectedToCompare would leave the rest behind.
          // Remove every saved entry so the slotNumbers array empties.
          const allPlaylist = (playlist || []).map((p) => String(p.slotNumber));
          if (allPlaylist.length === 0) return;
          handleDeletePlaylistBulk(allPlaylist, String(userId), String(casinoId));
          slotCompareCommands.clearSlots();
          return;
        }
        if (isPlaylistRemoveMode) {
          const toRemove = selectedToCompare
            .filter((slot) => isIncludedInPlaylist(slot, playlist))
            .map((slot) => String(slot));
          if (toRemove.length === 0) return;
          handleDeletePlaylistBulk(toRemove, String(userId), String(casinoId));
          slotCompareCommands.clearSlots();
          return;
        }
        const toAdd = selectedToCompare
          .filter((slot) => !isIncludedInPlaylist(slot, playlist))
          .map((slot) => String(slot));
        if (toAdd.length === 0) return;
        handleInsertPlaylistBulk(toAdd, String(userId), String(casinoId));
      }}
      onCompareSlot={() => {
        slotCompareCommands.startComparing({ exploreInsight: tabSelectedInsight });
      }}
      onExitCompare={() => {
        slotCompareCommands.stopComparing();
      }}
    />
  ) : null;

  const renderSlotListContent = () => (
    <div
      id="slotList"
      className={clsx(
        'box box-list ',
        currentSnap === SnapPoint.Max ? 'box-mid-open' : 'box-close',
        exploreListPhaseClass(skeletonPhase)
      )}
      style={{
        backgroundImage:
          isExploreV2 && casinoSchema?.casinoName
            ? `url(${getHotListReportBackgroundImage(casinoSchema.casinoName)})`
            : undefined,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'top center',
        backgroundSize: 'cover',
      }}
    >
      <UserMessages
        visible={userMessagesVisible}
        title={currentMessage?.title ?? ''}
        description={currentMessage?.description ?? ''}
        onClose={() => {
          if (currentMessage) {
            handleUserMessagesClose();
            return;
          }
          setUserMessagesVisible(false);
        }}
      />
      <IonContent
        ref={listContentRef}
        className="list-report-content"
        scrollEvents={true}
        onIonScroll={(event) => {
          const rawScrollTop = event.detail.scrollTop;
          // Re-bind whenever the cached scroller is missing or detached (IonContent
          // remounts when leaving EGM Details). Never use a dead node's metrics for
          // atBottom — that used to early-return and block filter restore.
          let el = listScrollElRef.current;
          if (!isLiveScrollElement(el)) {
            listScrollElRef.current = null;
            el = null;
            void listContentRef.current?.getScrollElement().then((resolved) => {
              if (isLiveScrollElement(resolved)) {
                listScrollElRef.current = resolved;
              }
            });
          }
          // Clamp + near-bottom band match ListSheet so rubber-band values and
          // late footer/filter toggles don't fight the end stop.
          const scrollTop = el
            ? clampScrollTop(rawScrollTop, el.scrollHeight, el.clientHeight)
            : Math.max(0, rawScrollTop);
          const atBottom = el
            ? isScrollNearBottom({
                scrollTop,
                scrollHeight: el.scrollHeight,
                clientHeight: el.clientHeight,
                thresholdPx: DRAWER_SCROLL_NEAR_BOTTOM_PX,
              })
            : false;
          handleDrawerPanelScroll(scrollTop, atBottom);
        }}
        forceOverscroll={false}
        style={{
          height: '100%',
          maxHeight: '100%',
          overflowY: 'auto',
          // `none` so the top of the list is a hard stop (no rubber-band gap).
          // The effective scroller is ::part(scroll), styled in SCSS to match.
          overscrollBehaviorY: 'none',
          WebkitOverflowScrolling: 'touch',
          background: 'transparent',
        }}
      >
        {skeletonPhase.mounted && (
          <ExploreLoadingSkeleton
            visible={skeletonPhase.visible}
            finale={skeletonPhase.finale}
            logoSrc={reelLogoSrc}
            reels={showLoadingReels}
          />
        )}
        {isListReportLoading && !showListSkeleton && (
          <div className="spinner-loading">
            <div
              style={{
                position: 'relative',
                width: '100%',
                height: 100,
              }}
            >
              <SVGComponent />
            </div>
          </div>
        )}
        {visibleHotDataList?.length === 0 &&
          !isListReportLoading &&
          !isCasinoLoading &&
          !isSlotPlayDataIsLoading &&
          listType === 'standard' &&
          !isFavoritesActive &&
          !isPlaylistActive &&
          !isSelectedActive && (
          <NoDetailsNotice />
        )}
        {showFavoritesEmptyNotice && <FavoritesEmptyNotice />}
        {showPlaylistEmptyNotice && <PlaylistEmptyNotice />}
        {isFavoritesNoJackpotState && (
          <NoDetailsNotice message="None of your Favorites have hit a jackpot in the timeframe selected" />
        )}
        {isPlaylistNoJackpotState && (
          <NoDetailsNotice message="None of the slots in your Playlist have hit a jackpot in the selected timeframe" />
        )}
        {/* Sticky list head — the action pills (when a selection exists) and the
            column header are pinned together as ONE sticky element, so the header
            always docks flush beneath the pills (no measured offset, no gap). */}
        {(showComparePills || showHotDataTable) && (
          <div className="list-sticky-head">
            {!featureFlags.drawerActionButtons && actionPills}
            {showHotDataTable && (
              <IonRow className="slot-row">
                <IonCol size={isLandscape ? '3' : '7'} className="slot-name-label">
                  <div className="insight-header-title">
                    <button
                      type="button"
                      className={clsx(
                        'select-all-action',
                        selectBoxSelectedCount > 0 && 'select-all-action--selected'
                      )}
                      aria-label={
                        selectBoxSelectedCount > 0
                          ? isPlaylistActive
                            ? `Clear ${selectBoxSelectedCount} selected in Playlist`
                            : isFavoritesActive
                              ? `Clear ${selectBoxSelectedCount} selected in Favorites`
                              : `Clear ${selectBoxSelectedCount} selected`
                          : useSelectAll
                            ? 'Select all'
                            : 'Select top 10'
                      }
                      onClick={() => {
                        if (selectBoxSelectedCount > 0) {
                          if (isListScopedSelect) {
                            // Deselect only the EGMs shown in this list; keep any
                            // selection made in other lists.
                            slotCompareCommands.setSlotNumbers({
                              slotNumbers: selectedToCompare.filter(
                                (slot) => !displayedSlotSet.has(slot)
                              ),
                            });
                          } else {
                            slotCompareCommands.clearSlots();
                          }
                        } else if (isListScopedSelect) {
                          // Favorites/Playlist: add every shown row to the existing
                          // selection (don't drop other-list selections).
                          slotCompareCommands.setSlotNumbers({
                            slotNumbers: Array.from(
                              new Set([
                                ...selectedToCompare,
                                ...visibleHotDataList
                                  .map((d) => egmDetailId(d))
                                  .filter((n): n is number => n !== null),
                              ])
                            ),
                          });
                        } else if (isSlotFilterActive) {
                          // Title / Theme / Bank / search: select ALL filtered EGMs.
                          slotCompareCommands.setSlotNumbers({
                            slotNumbers: visibleHotDataList
                              .map((d) => egmDetailId(d))
                              .filter((n): n is number => n !== null),
                          });
                        } else {
                          // Unfiltered EGM list selects only the top 10.
                          slotCompareCommands.setSlotNumbers({
                            slotNumbers: visibleHotDataList
                              .slice(0, SELECT_TOP_LIMIT)
                              .map((d) => egmDetailId(d))
                              .filter((n): n is number => n !== null),
                          });
                        }
                      }}
                    >
                      {selectBoxSelectedCount > 0 ? (
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" />
                      ) : (
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                          <path d="M15.7969 0.0126953C17.0342 0.138588 17.9998 1.18358 18 2.4541V15.5459L17.9873 15.7969C17.8698 16.9517 16.9517 17.8698 15.7969 17.9873L15.5459 18H2.4541C1.18358 17.9998 0.138588 17.0342 0.0126953 15.7969L0 15.5459V2.4541C0.000240314 1.09885 1.09885 0.000239879 2.4541 0H15.5459L15.7969 0.0126953ZM2.4541 1C1.65113 1.00024 1.00024 1.65113 1 2.4541V15.5459C1.00024 16.3489 1.65113 16.9998 2.4541 17H15.5459C16.3489 16.9998 16.9998 16.3489 17 15.5459V2.4541C16.9998 1.65113 16.3489 1.00024 15.5459 1H2.4541Z" fill="white" />
                        </svg>
                      )}
                    </button>
                    {selectBoxSelectedCount > 0
                      ? isPlaylistActive
                        ? `Clear Selected (${selectBoxSelectedCount}) in Playlist`
                        : isFavoritesActive
                          ? `Clear Selected (${selectBoxSelectedCount}) in Favorites`
                          : `${areAllSelected ? 'All Selected' : 'Selected'} (${
                            selectBoxSelectedCount
                          })`
                      : useSelectAll
                        ? 'Select All'
                        : visibleHotDataList.length > SELECT_TOP_LIMIT
                          ? 'Select Top 10 in the List'
                          : 'Select All'}
                  </div>
                </IonCol>

                <HotListHeader
                  isAdvancedDisplayState={isProUser && isLandscape}
                  totalCount={totalCount.toString()}
                  onSelect={(rowData) => handleSortChange(rowData.insight)}
                  selectedInsight={tabSelectedInsight}
                  sortOrder={casinoParams.insight}
                  sortBy={casinoParams.orderby}
                  advancedViewInsights={advancedViewInsights}
                  activeInsightFilter={activeInsightFilter}
                  listType={listType}
                />
              </IonRow>
            )}
          </div>
        )}
        {/* Hot-list rows */}
        {showHotDataTable && (
          <>
            <HotListReport
              slotData={jackpotFilteredPlayData}
              hotlist_detail={visibleHotDataList}
              trendComparisonMap={trendComparisonMap}
              insightKey={tabSelectedInsight}
              timeframeKey={tabSelectedTimeframe}
              listType={listType}
              advancedViewInsights={advancedViewInsights}
              isAdvancedDisplayState={isProUser && isLandscape}
              // Favorites/Playlist/Filter views pin every EGM on the map, so number
              // every list row 1..N to match; standard view stays capped at TOP_SLOTS_LENGTH.
              numberAllRows={isFavoritesActive || isPlaylistActive || selectedSlots.length > 0}
              focusedSlotNumber={focusedSlotNumber}
              focusSeq={focusSeq}
              onClickSlot={(data) => {
                if (!data) return;
                // Insight: mnum (egmDetailId). Legacy: slot_number.
                // Never floorLocation/'2A5' — that fails /slot ^[0-9]{1,32}$.
                const slotNumber = egmDetailId(data);
                if (slotNumber === null) return;
                // Default behaviour: a name tap opens the EGM detail immediately.
                if (!featureFlags.drawerActionButtons) {
                  addToSlotHistory(slotNumber);
                  return;
                }
                // drawerActionButtons: a single name tap both centres the map on the
                // EGM and opens its detail (matching the former two-tap/double-click flow).
                nameTapFocusedSlotRef.current = null;
                // onMap:false machines (and a mapless Explore) are list-only:
                // no show-on-map, just the detail.
                if (!isInsightCasino || canShowOnMap(data, isMapless)) {
                  mapFocusNonceRef.current += 1;
                  setMapFocusSlot({ slotNumber, nonce: mapFocusNonceRef.current });
                }
                addToSlotHistory(slotNumber);
              }}
            />

            {/* Stable bottom row: same reserved height for loading + end state
                so spinner insert/remove / display:none cannot resize the list
                under a bottom-pinned scrollTop (the main Explore stutter). */}
            <div className="list-bottom-status">
              {!isEndReached ? (
                <IonInfiniteScroll
                  threshold="100px"
                  disabled={isEndReached}
                  ref={ionInfiniteScrollRef}
                  onIonInfinite={handleFetchMore}
                >
                  <IonInfiniteScrollContent
                    loadingSpinner="bubbles"
                    loadingText="Loading more..."
                  />
                </IonInfiniteScroll>
              ) : (
                <div className="list-bottom-status__end" role="status">
                  End of list
                </div>
              )}
            </div>
          </>
        )}
      </IonContent>
    </div>
  );

  const handleSnapChange = (snap: SnapPointType) => {
    currentSnapRef.current = snap;
    setCurrentSnap(snap);
  };

  // Double-tapping a pin toggles selection: an unselected EGM becomes selected (reuse
  // compare selection so the row highlights) and a selected EGM is deselected. (A single
  // tap opens the detail; selection is the double tap.) We intentionally do not change the
  // drawer snap here — moving the drawer also shifts mapBottomPadding, which resizes/
  // re-bounds the map and hides the header, which felt jarring.
  const handleMapPinSelect = (slotNumber: number) => {
    if (!Number.isFinite(slotNumber)) return;
    const wasSelected = selectedToCompare.includes(slotNumber);
    // Tapping a pin must not move/zoom the map; suppress the fly-to-on-select effect.
    if (!wasSelected) suppressNextMapFocusRef.current = true;
    slotCompareCommands.toggleSelectedSlot({ slotNumber });
    // Deselect: no row to scroll to, so skip the focus/footer steps.
    if (wasSelected) return;
    // The list scrolls this row into view (HotListReport: ~120ms defer + 300ms
    // animation). Keep the footer visible across that window instead of letting
    // the auto-scroll hide it.
    suppressFooterHideUntilRef.current = Date.now() + 700;
    if (!isFooterVisible) emitFooterVisibility(true);
    setFocusedSlotNumber(slotNumber);
    setFocusSeq((seq) => seq + 1);
  };
  // Open the compare drawer to fit its content (capped at 100%) once, when the
  // user enters compare mode. The actual snap fires from the content-height
  // callback below, because the drawer height depends on how tall the rendered
  // comparison rows are — which is only known after CompareAdvancedView renders
  // the selected EGMs. A pending flag bridges the gap between "compare opened"
  // and "content measured".
  const pendingCompareFitRef = React.useRef(false);
  const prevComparingForFitRef = React.useRef(isComparing);
  useEffect(() => {
    if (!prevComparingForFitRef.current && isComparing) {
      pendingCompareFitRef.current = true;
    }
    prevComparingForFitRef.current = isComparing;
  }, [isComparing]);

  const handleCompareContentHeight = React.useCallback((height: number) => {
    setCompareContentHeight(height);
    // First measurement after compare opened → snap the drawer to fit. Cleared
    // so later content changes (add/remove EGM, resize) don't yank the drawer
    // back while the user is interacting with it.
    if (pendingCompareFitRef.current && height > 0) {
      pendingCompareFitRef.current = false;
      setCompareFitSeq((s) => s + 1);
    }
  }, []);

  // When exiting compare in portrait mode, reset drawer to 50%
  const prevComparingRef = React.useRef(isComparing);
  useEffect(() => {
    if (prevComparingRef.current && !isComparing) {
      if (isLandscapeOnly) {
        setDrawerForceSnap(SnapPoint.Quarter);
      } else {
        setDrawerForceSnap(SnapPoint.Half);
      }
      setTimeout(() => setDrawerForceSnap(null), 100);
    }
    prevComparingRef.current = isComparing;
  }, [isComparing, isLandscapeOnly]);


  const prevActiveSlotNumberRef = React.useRef(activeSlotNumber);
  useEffect(() => {
    const previousSlotNumber = prevActiveSlotNumberRef.current;
    const justOpenedDetail = !previousSlotNumber && !!activeSlotNumber;
    const justClosedDetail = !!previousSlotNumber && !activeSlotNumber;
    prevActiveSlotNumberRef.current = activeSlotNumber;

    // Opening a detail raises the drawer to 75% (map stays visible in the top
    // 25%). Closing must not leave it there — drop to Mid so the list map is
    // usable again. Only from the detail-open heights (ThreeQuarters / Full): if
    // the user already pulled the drawer to a shorter snap, keep that.
    const detailOpenSnaps: SnapPointType[] = [SnapPoint.ThreeQuarters, SnapPoint.Full];
    const nextSnap = justOpenedDetail
      ? SnapPoint.ThreeQuarters
      : justClosedDetail && detailOpenSnaps.includes(currentSnapRef.current)
        ? SnapPoint.Mid
        : null;
    if (nextSnap) {
      setDrawerForceSnap(nextSnap);
      const timer = window.setTimeout(() => setDrawerForceSnap(null), 100);
      return () => window.clearTimeout(timer);
    }
  }, [activeSlotNumber]);

  // List stays mounted under Details — keep the scroll element so close restores
  // the same position. Only re-bind if the ref was lost (e.g. first mount).
  useEffect(() => {
    if (activeSlotNumber) return;
    let cancelled = false;
    const syncListScroll = async () => {
      const content = listContentRef.current;
      if (!content) return;
      try {
        const el = await content.getScrollElement();
        if (cancelled || !isLiveScrollElement(el)) return;
        listScrollElRef.current = el;
        previousScrollTopRef.current = el.scrollTop;
      } catch {
        // IonContent may not be ready yet; the next onIonScroll will re-bind.
      }
    };
    void syncListScroll();
    return () => {
      cancelled = true;
    };
  }, [activeSlotNumber]);

  useEffect(() => {
    if (typeof totalCount !== 'number') return;
    const loaded = hotDataList ? hotDataList.length : 0;
    // Only advance to "ended" here — short-page end is set in fetchListReport.
    // Never clear an ended flag from a stale totalCount alone (filtered modes).
    if (totalCount > 0 && loaded >= totalCount) {
      setIsEndReached(true);
    }
  }, [hotDataList, totalCount]);

  // Standard list returned zero EGMs (done loading, not favorites/playlist).
  // Mirrors the condition that renders <NoDetailsNotice>; used to keep the
  // insight/timeframe toolbar visible so the user can adjust and recover.
  const isStandardEmptyState =
    visibleHotDataList?.length === 0 &&
    !isListReportLoading &&
    !isCasinoLoading &&
    !isSlotPlayDataIsLoading &&
    listType === 'standard' &&
    !isFavoritesActive &&
    !isPlaylistActive;

  // Any empty state where the map should be cleared (standard no-match, or an
  // active Favorites/Playlist filter with nothing saved to it).
  const isAnyEmptyState = isStandardEmptyState || isFavoritesEmptyState || isPlaylistEmptyState;

  // Keep the insight/timeframe toolbar visible for the standard no-match empty
  // state and the Favorites/Playlist no-jackpot states, so the user can switch
  // insight or timeframe to recover. When the Favorites/Playlist filter is on
  // but the user has nothing saved, hide the toolbar entirely — there is nothing
  // to sort or filter, so only the dedicated "is Empty" message should show.
  const shouldShowToolbarWhenEmpty =
    isStandardEmptyState || isFavoritesNoJackpotState || isPlaylistNoJackpotState;

  // A Game Name/Title search (a search selection, not a floor-map bank filter)
  // restricts the list to the matching slot numbers. The map must honor the
  // same restriction — same as Favorites/Playlist — so non-matching EGMs are
  // neither plotted with data nor clickable on the map.
  const isGameOrThemeFilter = selectedSlots.length > 0 && !isBankFilter;
  // Bank filters (map label tap or Search "Bank …") also narrow the map pins /
  // heat to the selected mnums — previously mapFilterSlotNumbers skipped them.
  const isSelectedSlotsMapFilter = selectedSlots.length > 0;

  // The slot numbers the MAP filters by. The map mirrors the list filter: when the
  // Selected (n) pill, Favorites/Playlist, a Game Name/Theme search, or a bank
  // filter is active the map plots that same slot set (casinoParams.slotnumbers,
  // which stays synced to the live selection). null = no filter (plot the full
  // floor / top-bottom 10 cap of the All view).
  // In challenge mode the map is narrowed to the challenge's EGMs (selectedSlots)
  // and filtered client-side — the play-data request no longer carries the slot
  // list (it would blow the gateway's query-string limit), so the map plots the
  // full floor and mapSlotData restricts it to the challenge's slots here. Gate on
  // challengeName (set on every Explore path). When a challenge has no EGMs,
  // selectedSlots is empty and the map falls back to the full floor.
  const mapFilterSlotNumbers = challengeName
    ? selectedSlots.length > 0
      ? selectedSlots.join(',')
      : null
    : isSelectedActive || isFavoritesActive || isPlaylistActive || isSelectedSlotsMapFilter
      ? casinoParams.slotnumbers || null
      : null;

  // Jackpots / JW/S: strip zero amount/count EGMs from the map + pin-number
  // source so heat/pins match the filtered list (frontend-only).
  const jackpotFilteredPlayData = useMemo(
    () => (playData ? rejectZeroJackpotEgms(playData, tabSelectedInsight) : playData),
    [playData, tabSelectedInsight]
  );

  // The map's data source (GetPlayDataReport) does not honor the slotnumbers
  // filter server-side, so when a Favorites/Playlist/Game-Name filter is active
  // the map would otherwise plot (and allow clicking) every EGM. Filter the play
  // data client-side to the map's filter set. Dual-key like the list (mnum OR
  // slot_number/floorLocation) so Search chips that stored floor codes still
  // light pins/heat. Clicks are gated by membership in this data
  // (FloorMap.findPlayDataSlot), so filtering it also blocks taps on EGMs that
  // don't meet the filter.
  const mapSlotData = useMemo(
    () =>
      filterRowsBySlotFilter(jackpotFilteredPlayData, mapFilterSlotNumbers) ??
      jackpotFilteredPlayData,
    [jackpotFilteredPlayData, mapFilterSlotNumbers]
  );

  return (
    <div className="mapstats">
      {/* DropdownBar hidden on home screen - InsightSelector and TimeFrameSelector not shown here */}

      {/* Show FloorMap except in CompareLandscape */}

      <div className="box">
        <ShortcutBar
          shortcuts={SHORTCUTS}
          activeId={activeShortcutId}
          onSelect={handleShortcutSelect}
          onSearchBubbleRemove={() => handleInputChange('slotnumbers', '')}
          searchBubble={
            !isEgmRefreshing &&
            !showFullScreenSpinner &&
            (challengeName || (selectedSlotsName && selectedSlots.length > 0)) ? (
              <RemovableTag
                text={challengeName ?? selectedSlotsName}
                bankFilter={isBankFilter}
                onRemove={() => handleInputChange('slotnumbers', '')}
              />
            ) : undefined
          }
          // Compare action, inline at the end of the filter row — mirrors the
          // Compare pill in the EGM drawer (same icon + startComparing action).
          // Shown only when 2+ EGMs are selected and we're not already comparing.
          // Suppressed when the drawerActionButtons flag is on: the floating
          // pills above the drawer already include a Compare action, so the
          // top-of-map one would be redundant.
          trailing={
            !isEgmRefreshing &&
            !featureFlags.drawerActionButtons &&
            !activeSlotNumber &&
            !isComparing &&
            selectedToCompare.length >= 2 ? (
              <IonButton
                size="small"
                className="compare-btn shortcut-bar__compare"
                onClick={() =>
                  slotCompareCommands.startComparing({ exploreInsight: tabSelectedInsight })
                }
              >
                <IonIcon
                  slot="start"
                  className="compare-btn__icon compare-btn__icon--compare"
                  icon="assets/icon/compare-icon.svg"
                />
                Compare
              </IonButton>
            ) : undefined
          }
        />
        {/* Keep FloorMap mounted once geometry exists (including under the first-load
            spinner). hideEgmOverlays clears heat/pins/legend/controls until data lands. */}
        {!isMapless &&
          !getGeoJsonLoading &&
          !!geoJsonData &&
          (activeSlotNumber ? (
            <FloorMap
              mapId={MapTypeEnum.individualReportMap}
              slotData={isEgmRefreshing ? EMPTY_MAP_SLOT_DATA : playData}
              cloakedSlotNumbers={cloakedMnums}
              slotDataIsLoading={isEgmRefreshing ? false : isSlotPlayDataIsLoading}
              hideEgmOverlays={isEgmRefreshing}
              individualSlotNumber={activeSlotNumber}
              selectedInsight={tabSelectedInsight}
              selectedTimeFrame={tabSelectedTimeframe}
              sortDirection={OrderByEnum.Desc}
              shouldHideSlotMark={false}
              isShowData={true}
              selectedSlots={selectedSlots}
              // Drives the focused EGM's star color: gold when it's selected, white when not.
              starredSlotNumbers={isEgmRefreshing ? [] : selectedToCompare}
              geoJsonData={geoJsonData}
              getGeoJsonLoading={getGeoJsonLoading}
              slotMetaData={slotMetaData}
              setFloormapLoading={setSlotPlayDataIsLoading}
              onClickHeatFilter={(selectedValue: number) => {
                floormapCommand.SetHeatFilterAction(selectedValue);
              }}
              onSelectHeatLevels={(heatLevels: number[]) => {
                floormapCommand.SetDefaultHeatFilterAction(heatLevels);
              }}
              coldFocus={isColdSortView}
              // On the EGM detail map, tapping a *different* EGM switches the detail to
              // that EGM. Tapping the EGM already shown in the detail toggles its
              // selection: select it when unselected, deselect it when selected.
              onClickSlot={(data) => {
                if (isEgmRefreshing) return;
                const slotNumber = egmDetailId(data);
                if (slotNumber === null) return;
                // activeSlotNumber is egmDetailId (insight mnum / legacy slot_number).
                if (slotNumber === Number(activeSlotNumber)) {
                  handleMapPinSelect(slotNumber);
                } else {
                  addToSlotHistory(slotNumber);
                }
              }}
              mapBottomPadding={mapBottomPadding}
              drawerDragging={isDrawerDragging}
            />
          ) : (
            <FloorMap
              mapId={MapTypeEnum.slotReportMap}
              slotData={
                isEgmRefreshing || isAnyEmptyState ? EMPTY_MAP_SLOT_DATA : mapSlotData
              }
              cloakedSlotNumbers={cloakedMnums}
              slotDataIsLoading={isEgmRefreshing ? false : isSlotPlayDataIsLoading}
              hideEgmOverlays={isEgmRefreshing}
              sortDirection={casinoParams.orderby}
              previousSelectedSlotNumber={activeSlotNumber}
              shouldHideSlotMark={true}
              selectedInsight={tabSelectedInsight}
              selectedTimeFrame={tabSelectedTimeframe}
              isShowData={true}
              selectedSlots={isComparing ? compareSlots : selectedSlots}
              // Pin the full filtered set (no top/bottom 10 cap) whenever the map is
              // restricted to a floor filter — the Selected (n) pill, Favorites/Playlist,
              // a Game Name/Theme search, or a bank filter — so every EGM in the
              // narrowed set gets a numbered pin. With no filter the All view keeps
              // its top/bottom 10 cap.
              showAllMarkers={!isComparing && !!mapFilterSlotNumbers}
              geoJsonData={geoJsonData}
              getGeoJsonLoading={getGeoJsonLoading}
              slotMetaData={slotMetaData}
              starredSlotNumbers={isEgmRefreshing ? [] : selectedToCompare}
              mapFocusSlot={isEgmRefreshing ? null : mapFocusSlot}
              onMapMove={handleMapUserMove}
              onClickBankLabel={isEgmRefreshing ? undefined : handleBankLabelClick}
              onClickHeatFilter={(value) => floormapCommand.SetHeatFilterAction(value)}
              onSelectHeatLevels={(heatLevels: number[]) =>
                floormapCommand.SetDefaultHeatFilterAction(heatLevels)
              }
              coldFocus={isColdSortView}
              // With no detail open, a single tap opens the EGM detail; a double tap
              // selects it (toggles it into the compare/selected set).
              onClickSlot={(data) => {
                if (isEgmRefreshing) return;
                // Map tap while list filters are collapsed restores insight/timeframe.
                showDrawerFilters();
                const slotNumber = egmDetailId(data);
                if (slotNumber === null) return;
                addToSlotHistory(slotNumber);
              }}
              onDoubleClickSlot={(data) => {
                if (isEgmRefreshing) return;
                showDrawerFilters();
                const slotNumber = egmDetailId(data);
                if (slotNumber === null) return;
                handleMapPinSelect(slotNumber);
              }}
              setFloormapLoading={setSlotPlayDataIsLoading}
              mapBottomPadding={mapBottomPadding}
              drawerDragging={isDrawerDragging}
            />
          ))}

        {isInsightCasino && isInsightGeoJsonLoading && (
          <div className="insight-map-skeleton" aria-busy="true" aria-label="Loading floor map" />
        )}
        {isInsightCasino && geoJsonError && !isInsightGeoJsonLoading && (
          <div className="insight-map-retry" role="status">
            Floor map unavailable.{' '}
            <button type="button" className="insight-map-retry__btn" onClick={retryGeoJson}>
              Retry
            </button>
          </div>
        )}

        {/* Search bubble and the Compare action are rendered inline inside ShortcutBar */}
      </div>

      {/* Drawer: hidden on map-casino first load until EGM data arrives; kept
          during timeframe refreshes with header chrome faded out. */}
      {showDrawer && (
        <>
          {/* Portrait and Landscape: show ListSheet */}
          {viewMode === ViewMode.Portrait && (
            <ListSheet
              totalReportCount={totalCount}
              groupGameName={selectedSlotsName}
              onSnapChange={handleSnapChange}
              forceSnap={drawerForceSnap}
              // Seed snap from the last user position so a closed drawer stays
              // closed if the sheet remounts (e.g. view-mode changes).
              initialSnap={currentSnap}
              isBankFilter={isBankFilter}
              isShowResultToolBar={!activeSlotNumber}
              showToolbarWhenEmpty={shouldShowToolbarWhenEmpty}
              onStatsRefChange={statsRef}
              isLandscape={isLandscapeOnly}
              insightKey={casinoParams.insight}
              orderBy={casinoParams.orderby}
              timeframeKey={tabSelectedTimeframe}
              isFooterVisible={isFooterVisible}
              filtersVisible={isDrawerFiltersVisible}
              sectionsCollapsed={exploreSectionsCollapsed}
              onScrollContent={handleDrawerPanelScroll}
              onTranslateYChange={handleDrawerTranslateY}
              onDragStateChange={setIsDrawerDragging}
              onHeaderDoubleTap={handleScrollListToTop}
              actionButtons={
                featureFlags.drawerActionButtons && !activeSlotNumber && !isEgmRefreshing
                  ? actionPills
                  : undefined
              }
            >
              {/* Keep Explore list mounted under Details so close preserves scroll
                  / selection and does not remount → refetch GetCasinoInsights.
                  display:contents when visible so .box-list height:100% still fills
                  panel-content (a bare wrapper collapsed the list for every insight). */}
              <div
                style={exploreListMountStyle(!!activeSlotNumber)}
                aria-hidden={!!activeSlotNumber}
              >
                {renderSlotListContent()}
              </div>
              {activeSlotNumber
                ? featureFlags.detailReportV2
                  ? (
                    <DetailReportV2
                      onStatsRefChange={setStatsRef}
                      onBackSlotList={() => clearSlotHistory()}
                      setSelectedSlotAction={setSelectedSlot}
                    />
                  )
                  : (
                    <DetailReport
                      onStatsRefChange={setStatsRef}
                      onBackSlotList={() => clearSlotHistory()}
                      setSelectedSlotAction={setSelectedSlot}
                    />
                  )
                : null}
            </ListSheet>
          )}
          {/* CompareLandscape: show only CompareView */}
          {viewMode === ViewMode.CompareLandscape && (
            <ListSheet
              totalReportCount={totalCount}
              groupGameName={selectedSlotsName}
              onSnapChange={handleSnapChange}
              isBankFilter={isBankFilter}
              isShowResultToolBar={!activeSlotNumber}
              onStatsRefChange={statsRef}
              isLandscape={isLandscapeOnly}
              initialSnap={SnapPoint.Full}
              insightKey={casinoParams.insight}
              orderBy={casinoParams.orderby}
              timeframeKey={tabSelectedTimeframe}
              isFooterVisible={isFooterVisible}
              filtersVisible={isDrawerFiltersVisible}
              headerChromeVisible={!hideDrawerChrome}
              onScrollContent={handleDrawerPanelScroll}
              onTranslateYChange={handleDrawerTranslateY}
              onDragStateChange={setIsDrawerDragging}
            >
              <div
                style={exploreListMountStyle(!!activeSlotNumber)}
                aria-hidden={!!activeSlotNumber}
              >
                <CompareAdvancedView
                  viewMode={viewMode}
                  onViewSlot={(slotNumber) => addToSlotHistory(Number(slotNumber))}
                />
              </div>
              {activeSlotNumber
                ? featureFlags.detailReportV2
                  ? (
                    <DetailReportV2
                      onStatsRefChange={setStatsRef}
                      onBackSlotList={() => clearSlotHistory()}
                      setSelectedSlotAction={setSelectedSlot}
                    />
                  )
                  : (
                    <DetailReport
                      onStatsRefChange={setStatsRef}
                      onBackSlotList={() => clearSlotHistory()}
                      setSelectedSlotAction={setSelectedSlot}
                    />
                  )
                : null}
            </ListSheet>
          )}

          {viewMode === ViewMode.ComparePortrait && (
            <ListSheet
              totalReportCount={totalCount}
              groupGameName={selectedSlotsName}
              onSnapChange={handleSnapChange}
              isBankFilter={isBankFilter}
              isShowResultToolBar={false}
              onStatsRefChange={statsRef}
              isLandscape={isLandscapeOnly}
              insightKey={casinoParams.insight}
              orderBy={casinoParams.orderby}
              timeframeKey={tabSelectedTimeframe}
              isFooterVisible={isFooterVisible}
              filtersVisible={isDrawerFiltersVisible}
              headerChromeVisible={!hideDrawerChrome}
              onScrollContent={handleDrawerPanelScroll}
              onTranslateYChange={handleDrawerTranslateY}
              onDragStateChange={setIsDrawerDragging}
              fitContentHeight={compareContentHeight}
              fitContentSeq={compareFitSeq}
            >
              <div
                style={exploreListMountStyle(!!activeSlotNumber)}
                aria-hidden={!!activeSlotNumber}
              >
                <CompareAdvancedView
                  viewMode={viewMode}
                  onContentHeightChange={handleCompareContentHeight}
                  onViewSlot={(slotNumber) => addToSlotHistory(Number(slotNumber))}
                />
              </div>
              {activeSlotNumber
                ? featureFlags.detailReportV2
                  ? (
                    <DetailReportV2
                      onStatsRefChange={setStatsRef}
                      onBackSlotList={() => clearSlotHistory()}
                      setSelectedSlotAction={setSelectedSlot}
                    />
                  )
                  : (
                    <DetailReport
                      onStatsRefChange={setStatsRef}
                      onBackSlotList={() => clearSlotHistory()}
                      setSelectedSlotAction={setSelectedSlot}
                    />
                  )
                : null}
            </ListSheet>
          )}
        </>
      )}

      {/* First-load spinner: stays until EGM data arrives (map may paint underneath). */}
      {spinnerMounted && (
        <div
          className={`loader-container${
            spinnerOpaque ? ' loader-container--visible' : ' loader-container--hidden'
          }`}
          aria-hidden={!spinnerOpaque}
        >
          <div style={{ height: '100%', textAlign: 'center' }}>
            <SVGComponent message="" />
          </div>
        </div>
      )}
    </div>
  );
};

export default MapStats;
